/**
 * Resource file for all public facing string constants in the app
 */
 const en_us = {
  LOCALE_KEY: 'en_us',

  LOCALE_NAME: 'English US',

  MISSING_TRANSLATION: 'Missing translation',

  MAPPING_ERROR_BANNER_WARNING: 'Product Mapping Error! Please contact your local Resort Tools administrator to resolve. Check Mapping Status ',

  MAPPING_ERROR_BANNER_HERE: 'here',

  PRODUCT_MAPPING_PAGE_INFO: 'Enter local point of sale product information for active entitlements to enable integration to resort',

  VALIDATION_CONFIGURATION_PAGE_INFO: 'Adjust validity dates by entitlement. Usage outside of specified dates will not be valid',

// SystemAdminPage.tsx
  SYSTEM_ADMIN_PAGE_TITLE: 'System Admin',

  SAVE_CONFIG_ACTION_ERROR: 'There was an error saving the configuration.',

  SAVE_CONFIG_SUCCESS_MSG: 'Configuration saved successfully',

  GET_CONFIG_FETCH_ERROR: (resort: string) => `Unexpected error fetching the configuration settings for ${resort}. Using default configuration settings.`,

  FEATURE_TOGGLES: 'Feature Toggles',

  DIRECT_TO_WINDOW_LABEL: 'Direct to Window',

  IS_UAT_LABEL:  'Is UAT',

  IS_UAT_INFO: 'Whether or not the app is running in a User Acceptance Testing environment.',

  ALL_RESORTS_HOTLIST_LABEL: 'All Resorts Hotlist',

  ALL_RESORTS_HOTLIST_INFO: 'Allow hotlisting and unhotlisting guests from all resorts.',

  RESORT_SPECIFIC_HOTLIST_LABEL: 'Resort-Specific Hotlist',

  RESORT_SPECIFIC_HOTLIST_INFO: 'Allow hotlisting and unhotlisting guests from just this resort.',

  ADD_TO_HOTLIST_LABEL: 'Add to Hotlist',

  ADD_TO_HOTLIST_INFO: 'Allow hotlisting guests.',

  REMOVE_FROM_HOTLIST_LABEL: 'Remove from Hotlist',

  REMOVE_FROM_HOTLIST_INFO: 'Allow unhotlisting guests who are currently hotlisted.',

  REDEMPTION_WARNING_LABEL: 'Redemption Warning',

  REDEMPTION_WARNING_INFO: 'Show a warning to the user before allowing them to redeem an entitlement. Helpful for users who can\'t perform a corrective redemption.',

  GROUP_PRINT_LABEL: 'Group Print',

  GROUP_IMPORT_LABEL: 'Group Import',

  SHOW_CAMERA_MIRRORING_LABEL: 'Show Camera Mirroring',

  SHOW_CAMERA_MIRRORING_INFO: 'Allow users to flip web cam images horizontally to compensate for left-right reversal when pointing the web cam in certain directions.',

  VALIDATION_CONFIGURATION_LABEL: 'Validation Configuration',

  VALIDATION_CONFIGURATION_INFO: 'Allow users to view Validation Configuration for resort.',

  MAPPING_ERROR_BANNER_LABEL: 'Mapping Error Banner',

  MAPPING_ERROR_BANNER_INFO: 'Allow users to see product mapping error banner',

  BULK_UPLOAD_LABEL: 'Product Mapping Bulk Upload',

  BULK_UPLOAD_INFO: 'Allow users to use the product mapping bulk upload feature',

  BULK_UPLOAD_NEXT: 'Next >',

  BULK_UPLOAD_BACK: '< Back',

  SEARCH_HISTORY_LABEL: 'Search History',

  SEARCH_HISTORY_INFO: 'Allow users to see search history',

  ENABLE_CUSTOMER_IMPORT_LABEL: 'Enable Customer Import',

  ENABLE_CUSTOMER_IMPORT_INFO: 'Which roles can use customer import',

  ENABLE_DTW_LABEL: 'Enable DTW',

  ENABLE_DTW_INFO: 'Enable Direct-to-Window Ticket Redemption for this site for these roles',

  ENABLE_CORRECTIVE_REDEMPTION_LABEL: 'Enable Corrective Redemption',

  ENABLE_CORRECTIVE_REDEMPTION_INFO: 'Which roles can redeem negative values on DTW and/or F&F and/or View Days tab entitlements',

  MANAGE_USERS_LABEL: 'Manage Users',

  MANAGE_USERS_INFO: 'Who can manage user roles',

  MANAGE_DAYS_LABEL: 'Manage Days',

  MANAGE_DAYS_INFO: 'Who can manage day pass redemptions',

  ENABLE_HOTLIST_REPORT_LABEL: 'Enable Hotlist Report',

  ENABLE_HOTLIST_REPORT_INFO: 'Who can see the hotlist Report',

  ENABLE_GUEST_HYDRATION_REPORT_LABEL: 'Enable Guest Hydration Report',

  ENABLE_GUEST_HYDRATION_REPORT_INFO: 'Who can see guest hydration report',

  ENABLE_WEEKLY_VISITOR_REPORT_LABEL: 'Enable Weekly Visitor Report',

  ENABLE_WEEKLY_VISITOR_REPORT_INFO: 'Who can see the weekly visitor report',

  ENABLE_PASS_USAGE_CORRECTION_LABEL: 'Enable Pass Usage Correction',

  ENABLE_PASS_USAGE_CORRECTION_INFO: 'Who can access advanced pass usage correction features at the call center',

  ENABLE_CUSTOMER_MEDIA_UPDATE_LABEL: 'Enable Sync Customer Media',

  ENABLE_CUSTOMER_MEDIA_UPDATE_INFO: 'Should be true except for siriusware ww integration',

  ENABLE_LANGUAGE_LABEL: 'Enable Language',

  ENABLE_LANGUAGE_INFO: 'Allows users to set their language and datetime preferences',
  
  AUTO_LOGOUT_TIMER_LABEL: 'Auto Logout Timer (minutes)',

  AUTO_LOGOUT_TIMER_INFO: 'The amount of idle time in minutes before someone is automatically logged off',

  WEEKLY_VISITOR_REPORT_LIMIT_LABEL: 'Weekly Visitor Report Limit',

  WEEKLY_VISITOR_REPORT_LIMIT_INFO: 'The number of reports that can be retrieved. 0 indicates this feature is off for this resort.',

  ENABLE_PASS_REPRINT_NOTIFICATIONS_LABEL: 'Enable Pass Reprint Notifications',

  ENABLE_PASS_REPRINT_NOTIFICATIONS_INFO: 'Enable pass reprint charge notifications to be displayed for pass reprints.',

  DISPLAY_DEACTIVATED_MEDIA_HISTORY_LABEL: 'Display Deactivated Media History',

  DISPLAY_DEACTIVATED_MEDIA_HISTORY_INFO: 'Enable display of "Deactivated" for all non-active or dtl disabled media in the Media Card History modal.',

// PowCoin; Payment Methods and Registration
  POWCOIN_LABEL: 'Pay With Pass',

  POWCOIN_INFO: 'Allow users to view and deregister guest payment registrations',

  CHANGE_HISTORY_LABEL: 'Change History',

  CHANGE_HISTORY_INFO: 'Allow users to view change history',

  PAYMENT_REGISTRATION_GUEST_FIRST_NAME: 'First Name',

  PAYMENT_REGISTRATION_GUEST_NO_FIRST_NAME: 'No First Name',

  DEACTIVATE_PAYMENT_REGISTRATION: 'Remove payment registration',

  DEACTIVATE_PAYMENT_REGISTRATION_BUTTON: 'Remove',

  PAYMENT_REGISTRATION_WARNING: 'Payment registration and activation can only be completed through MyAccount on IkonPass.com by the guest.',

  PAYMENT_REGISTRATION_NO_REGISTRATIONS: 'No active payment registrations found for the current payment method.',

  PAYMENT_REGISTRATION_GUESTS: 'Authorized Guests',

  PAYMENT_REGISTRATION_DEACTIVATE_ALL: 'Deactivate for All',

  PAYMENT_REGISTRATION_EXPIRY: (expiryMonth: string, expiryYear: string) => `Exp: ${expiryMonth} / ${expiryYear}`,

  PAYMENT_REISTRATION_EXPIRED: 'Expired',

  PAYMENT_REGISTRATION_VIEW: 'Manage payment registrations',

  PAYMENT_REGISTRATION_ERROR_PAYMENT_METHOD_NOT_FOUND: 'Unexpected error trying to load the payment method.  Please refresh and try again.',

  DEACTIVATE_PAYMENT_REGISTRATION_ERROR:  'Failed to deactivate Pay With Pass registration for one or more family members. Please review and retry.',

  DEACTIVATED_PAYMENT_REGISTRATION: (firstName: string) => `Registration deactivated for ${firstName}`,

  GUEST_SNACKBAR_FAILED_PAYMENT_REGISTRATIONS: 'Unexpected error trying to load guest payment registrations.',

  PAYMENT_REGISTRATION_DEACTIVATE_ALL_CONFIRMATION: 'Are you sure you want to remove all the payment registrations?',

  PAYMENT_REGISTRATION_DEACTIVATE_CONFIRMATION: (guest: string) => `Are you sure you want to remove the payment registration for ${guest}?`,

  PAYMENT_REGISTRATION_DEACTIVATE_CANCEL: 'Cancel',

  PAYMENT_REGISTRATION_DEACTIVATE_SUCCEEDED: (guest: string) => `The payment registration for ${guest} has been successfully deactivated.`,

// User Management

  USER_MANAGEMENT_PAGE_TITLE: 'Manage Users',

  USER_MANAGEMENT_PAGE_INFO: 'The following fields are required for user creation: First, Last, Username, Role, Resort, and Password',

  BLOCK_USER_ACTION_ERROR: 'Failed to block user.',

  GET_USERS_ACTION_ERROR: 'Failed to fetch users.',

  UNBLOCK_USER_ACTION_ERROR: 'Failed to unblock user.',

  USER_FIELD_REQUIRED_VALIDATION: 'Required',

  USER_FIELD_INVALID_CHARACTERS: (invalidChars: string) => `Must not \ninclude \ncharacters: \n${invalidChars}`,

  USER_NAME_NOT_AVAILABLE: 'Username is \nnot available',

  USER_NAME_FORMAT_VALIDATION: 'Must be \n4 to 20 letters/numbers \nincluding underscore',

  USER_EMAIL_FORMAT_VALIDATION: 'Must be a \nvalid email \naddress',

  USER_EMAIL_NOT_AVAILABLE: 'Email is \nnot available',

  USER_PASSWORD_FORMAT_VALIDATION: 'Must have: \n• 8 or more characters \n• an uppercase letter \n• a lowercase letter \n• a number',

  USER_MANAGEMENT_FAILED_USERNAMES_ERROR: (failedUsernames: string) => `Failed network request for: ${failedUsernames}, the username or email might already be in use.`,

  USER_MANAGEMENT_CREATE_USER_SUCCESS: (userName: string) => `${userName} created successfully.`,

  USER_MANAGEMENT_FILTER_ERROR: (query: string) => `No users match ${query}.  If a user does not show on your list it is possible the user exists in another resort.`,

  USER_MANAGEMENT_USERS_PER_PAGE: 'Users per page',

  USER_MANAGEMENT_NO_USERS: 'No Users',

  USER_MANAGEMENT_ACCOUNT_DISABLED: 'account disabled',

  USER_MANAGEMENT_FETCH_USERS_FAILED: 'Failed to fetch users. Please refresh to try again.',

  USER_MANAGEMENT_REMOVE_USER_TITLE: 'Remove User?',

  USER_MANAGEMENT_REMOVE_USER_MSG: (userToDelete: string) => `Are you sure you want to remove ${userToDelete}?`,

  USER_MANAGEMENT_REMOVE_BUTTON: 'Remove',

  USER_MANAGEMENT_CANCEL_REMOVE_BUTTON: 'Cancel',

  USER_MANAGEMENT_TABLE_FIRST_NAME: 'First',

  USER_MANAGEMENT_TABLE_LAST_NAME: 'Last',

  USER_MANAGEMENT_TABLE_USERNAME: 'Username',

  USER_MANAGEMENT_TABLE_EMAIL: 'Email',

  USER_MANAGEMENT_TABLE_ROLE: 'Role',

  USER_MANAGEMENT_TABLE_RESORTS: 'Resorts',

  USER_MANAGEMENT_TABLE_PASSWORD: 'Password',

  USER_MANAGEMENT_TABLE_LAST_LOGIN: 'Last Login',

  USER_MANAGEMENT_TABLE_NO_USERS: 'No users.',

  USER_ROW_ALL_RESORTS: 'All Resorts',

  USER_ROW_SELECT_ALL: 'Select All',

  USER_ROW_EXPAND_RESORTS: 'Expand Resorts',

  USER_ROW_COLLAPSE_RESORTS: 'Collapse Resorts',

  USER_ROW_SELECT_PLACEHOLDER: 'Select...',

  USER_ROW_CREATE_USER: ' Create User',

  USER_ROW_SAVE_CHANGES: 'Save Changes',

  USER_ROW_DISCARD_CHANGES: 'Discard Changes',

  USER_ROW_UPDATE_USER: 'Update User',

  USER_ROW_DELETE_USER: 'Delete User',

  USER_ROW_FIRST_NAME: 'First Name',

  USER_ROW_LAST_NAME: 'Last Name',

  USER_ROW_USERNAME: 'Username',

  USER_ROW_SUGGESTED_USERNAME: (suggestedUsername: string) => `Suggested username  ${suggestedUsername}`,

  USER_ROW_EMAIL: 'Email',

  USER_ROW_USER_ROLE: 'User Role',

  USER_ROW_NO_ROLES: 'No Roles',

  USER_ROW_PASSWORD: 'Password',

  USER_ROW_UPDATE_PASSWORD: 'Update Password',

  USER_SEARCH_BOX_BLACKLIST_WARNING: 'Warning: Blacklisted Search Term',

  USER_SEARCH_BOX_TITLE: 'Search for a Resort Tools User',

  USER_SEARCH_BOX_SEARCH: 'Search',

  USER_SEARCH_BOX_PLACEHOLDER: 'Find a User',

  USER_EDIT_MENU_ENABLE_USER_TITLE: 'Enable user',

  USER_EDIT_MENU_DISABLE_USER_TITLE: 'Disable user',

  USER_EDIT_MENU_ENABLE_USER: 'Enable',

  USER_EDIT_MENU_DISABLE_USER: 'Disable',

  USER_EDIT_MENU_DELETE_USER_TITLE: 'Delete',

  USER_EDIT_MENU_RESET_PASSWORD: 'Reset PW',

  USER_EDIT_MENU_MORE_OPTIONS: 'More Options',

//User Preferences
  USER_PREFERENCE_MODAL_TITLE: 'Date & Language',

  USER_PREFERENCE_MODAL_INFO: 'Select preferred date format and language',

  USER_PREFERENCE_MODAL_LANGUAGE: 'Language:',

  USER_PREFERENCE_MODAL_DATE: 'Date Format:',

  USER_PREFERENCE_MODAL_NO_LANGUAGES_ERROR: 'No Languages, something went wrong',

  USER_PREFERENCE_MODAL_LANGUAGE_PLACEHOLDER: 'Select Language',

  USER_PREFERENCE_MODAL_NO_DATETIME_ERROR: 'No Date codes, something went wrong',

  USER_PREFERENCE_MODAL_DATETIME_PLACEHOLDER: 'Select Date Format',

  USER_PREFERENCE_MODAL_APPLY: 'Apply Changes',

  USER_PREFERENCE_MODAL_RESORT_DEFAULT: 'Resort Default',

// FAQ Pages
  FAQ_PAGE_TITLE: 'Frequently Asked Questions',

  FAQ_PAGE_FETCH_FAILED: 'Failed to fetch FAQs. Please refresh and try again.',

  FAQ_PAGE_NO_FAQ: 'There are no FAQs at this time. Please check back later for more info.',

  FAQ_PAGE_LOADING_FAQ: 'Loading FAQs',

  MAKE_FAQ_PAGE_NO_FAQ: 'No FAQs. Try creating a new one or uploading an existing JSON file above.',

  MAKE_FAQ_PAGE_MAKE_FAQ_JSON: 'Make FAQ JSON',

  MAKE_FAQ_PAGE_NEW_FAQ: 'New FAQ',

  MAKE_FAQ_PAGE_SAVE_FAQ: 'Save',

// Help and Training Pages
  HELP_TRAINING_PAGE_TITLE: 'Help and Training',

  HELP_TRAINING_LOADING: 'Loading documents',

  HELP_TRAINING_FETCH_FAILED: 'Failed to fetch training documents. Please refresh and try again.',

  HELP_TRAINING_NO_DOCS: 'There are no training documents at this time. Please check back later for more info.',

  HELP_TRAINING_VIEWER_FAILED: 'Failed to display this document. Please refresh and try again.',

  HELP_TRAINING_BACK: 'Back to documents',

  HELP_TRAINING_UPLOAD_BUTTON: 'Upload Document',

  HELP_TRAINING_REPLACE_BUTTON: 'Replace',

  HELP_TRAINING_DELETE_BUTTON: 'Delete',

  HELP_TRAINING_FORM_TITLE_UPLOAD: 'Upload Training Document',

  HELP_TRAINING_FORM_TITLE_REPLACE: 'Replace Training Document',

  HELP_TRAINING_FORM_FILE_LABEL: 'Document file (.docx)',

  HELP_TRAINING_FORM_DOC_TITLE_LABEL: 'Title',

  HELP_TRAINING_FORM_SORT_ORDER_LABEL: 'Sort order',

  HELP_TRAINING_FORM_SUBMIT: 'Save',

  HELP_TRAINING_FORM_CANCEL: 'Cancel',

  HELP_TRAINING_DELETE_CONFIRM_TITLE: 'Delete Document?',

  HELP_TRAINING_DELETE_CONFIRM_MSG: (title: string) => `Are you sure you want to delete "${title}"? This cannot be undone.`,

  HELP_TRAINING_WRITE_FAILED: 'That action failed. Please try again.',

// Release Notes Pages
  RELEASE_NOTES_PAGE_TITLE: 'Release Notes',

  RELEASE_NOTES_PAGE_LOADING: 'Loading Release Notes',

  RELEASE_NOTES_PAGE_NO_NOTES: 'There are no Release Notes at this time. Please check back later for more info.',

  RELEASE_NOTES_PAGE_FETCH_FAILED: 'Failed to fetch Release Notes. Please refresh and try again.',

  MAKE_RELEASE_NOTES_PAGE_JSON: 'Make Release Notes JSON',

  MAKE_RELEASE_NOTES_NO_NOTES: 'No Release Notes. Try creating a new one or uploading an existing JSON file above.',

  MAKE_RELEASE_NOTES_NEW_NOTE: 'New Note',

  MAKE_RELEASE_NOTES_SUBMIT_NOTES: ' Submit Release Notes',

// App Doc Form
  APP_DOC_FAQ_NEEDS_TITLE: 'This FAQ item needs a title!',

  APP_DOC_FAQ_NEEDS_BODY: 'This FAQ item needs a body!',

  APP_DOC_FAQ_ITEM_HEADER: 'FAQ Item',

  APP_DOC_FORM_LABEL_TITLE: 'Title',

  APP_DOC_FORM_LABEL_ROLES: 'Show for Roles',

  APP_DOC_FORM_SUBLABEL_ROLES: '(Paste new value)',

  APP_DOC_FORM_LABEL_DTW_RESORTS: 'For DTW Resorts',

  APP_DOC_FORM_SAVE: 'Save',

  APP_DOC_FORM_CANCEL: 'Cancel',

// Auth
  GET_CONFIG_ACTION_ERROR : 'Unexpected error fetching the app\'s config settings.',

  GET_USER_INFO_ACTION_ERROR: 'Failed to fetch user.',

  AUTH0_LOGIN_ERROR: 'Your account has been disabled.  Please contact your manager or an administrator.',

  AUTH0_LOGIN: 'Login',

  AUTH0_LOGIN_TITLE: 'Login to IKON Resort',

  LOGIN_FORM_APP_CONFIG_FETCH_FAILED: 'Failed to fetch app config',

  LOGIN_FORM_ALL_FIELDS_REQUIRED: 'All fields are required',

  LOGIN_FORM_ENTER_USERNAME: 'Enter your username',

  LOGIN_FORM_USERNAME: 'Username',

  LOGIN_FORM_ENTER_PASSWORD: 'Enter your password',

  LOGIN_FORM_PASSWORD: 'Password',

  LOGIN_FORM_LOGIN_TITLE: 'Login to IKON Resort',

  LOGIN_FORM_LOGIN: 'Login',

// Branding
  RESORT_TOOLS_LOGO_HEADER: 'Resort Tools',

// copyToClipboard
  COPIED_TO_CLIPBOARD: 'Copied to clipboard!',

  COPY_TO_CLIPBOARD: 'Copy to clipboard',

// core
  GET_APPLIANCE_VERSION_ACTION_ERROR: 'Unexpected error fetching the appliance version.',

// entitlementTypes
  GET_ENTITLEMENT_TYPES_ACTION_ERROR: 'Failed to load entitlement types. Please try again later.',

// entitlementTypesMetadata
  GET_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR: 'Failed to fetch entitlement types metadata.',

  UPDATE_ENTITLEMENT_TYPES_METADATA_ACTION_ERROR:  'Unexpected error updating entitlement types metadata.',

  GET_FNF_BLACKOUTDATES_METADATA_ACTION_ERROR: 'Failed to fetch friends and family blackout dates metadata.',

  GET_LIFT_BLACKOUTDATES_METADATA_ACTION_ERROR: 'Failed to fetch lift blackout dates metadata.',

// forms
  AUTO_FORM_SAVE: 'Save',

  AUTO_FORM_RESET: 'Reset',

  DROPDOWN_PLEASE_SELECT: 'Please select...',

  CHARACTER_COUNT_CHARACTERS: 'Characters:',

  PASSWORD_FIELD_SHOW_PASSWORD: 'Show Password',

  PASSWORD_FIELD_HIDE_PASSWORD: 'Hide Password',

  TOGGLE_SWITCH_ON: 'ON',

  TOGGLE_SWITCH_OFF: 'OFF',

// Landing page
  RESET_USER_PASSWORD_MISMATCH_ERROR: 'Passwords do not match, please re-enter your new password again',

  RESET_USER_PASSWORD_RESET_COMPLETE: 'Password Reset Complete!',

  RESET_USER_PASSWORD_CANCEL: 'CANCEL',

  RESET_USER_PASSWORD_OK: 'OK',

  RESET_USER_PASSWORD_PASSWORD_RESET: 'Password Reset',

  RESET_USER_PASSWORD_RESET_INSTRUCTIONS: 'Please enter your new password twice',

  RESET_USER_PASSWORD_PASSWORD_PLACEHOLDER: 'Password',

  RESET_USER_PASSWORD_CONNECTION_ERROR: 'Connection Error. Please Try Again Later',

  RESET_USER_PASSWORD_SAVE: 'SAVE',

// layout
  FLOATING_MENU_CLOSE: 'Close menu',

  FLOATING_MENU_OPEN: 'Open menu',

  MODAL_TITLE_HEADER_CLOSE: 'Close',

// pageHeader
  HEADER_MENU_SYSTEM_ADMIN: 'System Administration',

  HEADER_MENU_VALIDATION_CONFIG: 'Validation Configuration',

  HEADER_MENU_PRODUCT_ADMINISTRATION: 'Product Administration',

  HEADER_MENU_USER_MANAGEMENT: 'User Management',

  HEADER_MENU_HELP_AND_TRAINING: 'Help and Training',

  HEADER_MENU_FAQ: 'FAQ',

  HEADER_MENU_REPORTS: 'Reports',

  HEADER_MENU_RELEASE_NOTES: 'Release Notes',

  HEADER_MENU_SIGNOUT: 'Signout',

  HEADER_MENU_PRODUCT_MAPPING: 'Product Mapping',

  PAGE_HEADER_BACK_TO_LANDING: 'Back to Landing Page',

  PAGE_HEADER_SIGNED_IN_AS: (currentUser: string) => `Signed in as ${currentUser}`,

  PAGE_HEADER_SIGNED_IN_AS_WITH_ROLE: (currentUser: string, userRole: string) => `Signed in as ${currentUser} ${userRole}`,

  RESORT_SELECT_MENU_LOAD_CONFIG_ERROR: (resortName: string) => `Unexpected error fetching the configuration settings for ${resortName}. Using default configuration settings.`,

  RESORT_SELECT_MENU_UNSAVED_EDITS: 'Save or cancel your product mapping edits to switch resorts.',

  ENV_BANNER_DEV: 'DEV',

  ENV_BANNER_QA: 'QA',

  ENV_BANNER_UAT: 'UAT',

// resortDetails
  GET_RESORT_DETAILS_ACTION_ERROR: 'No resorts found in response',

// validationConfigurationTool
  VALIDATION_CONFIG_INVALID_EFFECTIVE_DATE: 'A valid start date is required.',

  VALIDATION_CONFIG_INVALID_EXPIRATION_DATE: 'A valid expire date is required.',

  VALIDATION_CONFIG_EXPIRES_BEFORE_EFFECTIVE_DATE: 'The product must expire on or after start date.',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The start date must be within one year of the season start date',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The start date must be less than the season end date',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The expire date must be within one year of the season end date',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The expire date must be greater than the season start date',

  VALIDATION_CONFIG_EFFECTIVE_DATE_OUTSIDE_SEASON_START: 'Warning: The start date is outside the season start date',

  VALIDATION_CONFIG_EXPIRATION_DATE_OUTSIDE_SEASON_END: 'Warning: The expire date is outside the season end date',

  VALIDATION_CONFIG_FAILED_NETWORK_REQUEST: 'Failed network request while updating resort validation configuration.  Please try again later.',

  VALIDATION_CONFIG_UNABLE_TO_SAVE: 'Unable to save products!  Please check all dates for errors.',

  VALIDATION_CONFIG_ERROR_OVERLAPPING_DATES: 'Product dates cannot overlap between Fulfillment Season',

  VALIDATION_CONFIG_CANCEL_EDITS: 'Cancel Edits',

  VALIDATION_CONFIG_EDIT_PRODUCTS: 'Edit Products',

  VALIDATION_CONFIG_SAVE_PRODUCTS: 'Save Products',

  VALIDATION_CONFIG_SAVE: 'Save',

  VALIDATION_CONFIG_CANCEL: 'Cancel',

  VALIDATION_CONFIG_SHOW_HISTORY: 'Show History',

  VALIDATION_CONFIG_HIDE_HISTORY: 'Hide History',

  VALIDATION_CONFIG_SAVE_PRODUCTS_CONFIRMATION: 'Are you sure you want to save products?',

  VALIDATION_CONFIG_DATA_CHANGE_WARNING : 'Any date range changes could affect live validations',

  VALIDATION_CONFIG_START_DATE_PLACEHOLDER: 'Start Date',

  VALIDATION_CONFIG_EXPIRE_DATE_PLACEHOLDER: 'Expire Date',

  VALIDATION_CONFIG_NO_DATA: 'There are no validation configurations for this resort.',

  VALIDATION_CONFIG_TABLE_PRODUCT: 'Product',

  VALIDATION_CONFIG_TABLE_SEASON: 'Season',

  VALIDATION_CONFIG_TABLE_FULFILLMENT_SEASON: 'Fulfillment Season',

  VALIDATION_CONFIG_TABLE_MAX_DAYS: 'Max Days',

  VALIDATION_CONFIG_TABLE_START_DATE: 'Start Date',

  VALIDATION_CONFIG_TABLE_EXPIRE_DATE: 'Expire Date',

  VALIDATION_CONFIG_TITLE: 'Resort Validation Configuration',

  VALIDATION_CONFIG_ROW_UNLIMITED: 'Unlimited',

  VALIDATION_CONFIG_ROW_MAX_DAYS: (maxDays: number) => `${maxDays} Days`,

  VALIDATION_CONFIG_ROW_START_DATE: 'Start Date',

  VALIDATION_CONFIG_ROW_EXPIRE_DATE: 'Expire Date',

  GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_ACTION_ERROR: 'Failed to fetch resort validation configuration change history.',

  LIFT_ACCESS_HISTORY_UPDATED: 'Updated',

  LIFT_ACCESS_HISTORY_USER: 'User',

  LIFT_ACCESS_HISTORY_VALUE: 'New Value',

  LIFT_ACCESS_HISTORY_UNKNOWN: 'Unknown',

  LIFT_ACCESS_HISTORY_USER_NOT_FOUND: 'User not found',

  LIFT_ACCESS_HISTORY_USER_LOADING: 'User loading',

// version
  CENTRAL_APPLIANCE_VERSION: 'Central Appliance Version',

  RESORT_TOOLS_VERSION: 'Resort Tools Version',

// webcam
  PHOTO_BOOTH_CAM: 'Cam',

  PHOTO_BOOTH_SELECT_WEBCAM: 'Select the WebCam to use to take pictures',

  PHOTO_BOOTH_SELECT_WEBCAM_PLACEHOLDER: 'Select a Cam',

  PHOTO_BOOTH_FLIP_CAMERA_FRAME_HORIZONTALLY: 'Flip the Camera Frame Horizontally',

  PHOTO_BOOTH_FLIP_CAMERA_IMAGE_HORIZONTALLY: 'Flip the camera image horizontally.',

  PHOTO_BOOTH_CANCEL_RETAKE: 'Cancel Retake and Use Previous Photo',

  PHOTO_BOOTH_TAKE_NEW_PICTURE: 'Take a New Picture',

  PHOTO_BOOTH_TAKE_PICTURE: 'Take Picture',

  PHOTO_BOOTH_SAVE_PICTURE: 'Save This Picture',

  PHOTO_BOOTH_SAVE: 'Save',

  PHOTO_BOOTH_RETAKE: 'Retake',

  PHOTO_BOOTH_CAPTURE: 'Capture',

  PHOTO_BOOTH_CANCEL: 'Cancel',

  PHOTO_BOOTH_REVERSE_CAMERA: 'Reverse Camera',

  WEBCAM_BROWSER_ERROR: 'This browser does not support native web cam capture.',

  WEBCAM_STREAMING_ERROR: 'Camera is not streaming.',

// resortMappingTool
  GET_RESORT_MAPPING_ACTION_ERROR: 'Unexpected error loading resort history.',

  PRODUCT_MAPPING_PAGE_MISSING_SALES_CHANNEL: 'Sales Channel Code may not be set for resort.',

  GET_RESORT_MAPPING_HAS_ERROR_ACTION_ERROR: 'Unexpected error loading resort product mapping error status.',

  GET_RESORT_MAPPINGS_NO_DATA: 'There are no resort product mappings found for this resort.',

  UPDATE_MAPPING_ERRORS_ACTION_ERROR: 'Unexpected error loading product mapping.',

  GET_PRODUCT_HYDRATION_ERRORS_ACTION_ERROR: 'Unexpected error loading product hydration errors.',

  PRODUCT_MAPPING_UPLOAD_TITLE: 'Bulk Upload Mappings',

  PRODUCT_MAPPING_UPLOAD_CLOSE: 'Close',

  PRODUCT_MAPPING_UPLOAD_UPLOAD: 'Upload',

  PRODUCT_MAPPING_UPLOAD_REVIEW: 'Review',

  PRODUCT_MAPPING_UPLOAD_ADD_FILE: 'Add File',

  PRODUCT_MAPPING_UPLOAD_DOWNLOAD: 'Download Mappings',

  PRODUCT_MAPPING_UPLOAD_ONE: 'Download Mappings to get all available products',

  PRODUCT_MAPPING_UPLOAD_ONE_WARNING: 'Only active products can be mapped',

  PRODUCT_MAPPING_UPLOAD_TWO: 'Use downloaded file to add relevant details to resort specific columns',

  PRODUCT_MAPPING_UPLOAD_TWO_WARNING: 'Maintain all existing column headers, these are essential for upload success',

  PRODUCT_MAPPING_UPLOAD_THREE: 'Drag and drop or find your edited file to attach it to the uploader',

  PRODUCT_MAPPING_UPLOAD_FOUR: 'Click Next button to review edits',

  PRODUCT_MAPPING_UPLOAD_CHOOSE_FILE: 'Choose a CSV file to upload',

  PRODUCT_MAPPING_UPLOAD_INSTRUCTION: 'Drag .csv file here or click Choose File',

  PRODUCT_MAPPING_UPLOAD_SUCCESS: 'Uploaded CSV Successfully!',

  PRODUCT_MAPPING_UPLOAD_WRONG_HEADERS: 'The Column Headers for the editable columns are incorrect or not in the right order',

  PRODUCT_MAPPING_UPLOAD_NOT_ENOUGH_COLUMNS: 'At least one row has fewer columns than expected',
  
  PRODUCT_MAPPING_UPLOAD_NO_MATCH: "No entitlement id matches found",

  PRODUCT_MAPPING_UPLOAD_NO_CHANGES: 'No changes were detected',

  PRODUCT_MAPPING_UPLOAD_NO_FILE: 'No file chosen',

  PRODUCT_MAPPING_UPLOAD_WRONG_FILE_TYPE: 'File is not a .csv file, please upload only .csv files',

  PRODUCT_MAPPING_UPLOAD_DUPLICATE_IDS: 'Duplicate Entitlement IDs detected',

  PRODUCT_MAPPING_UPLOAD_FILE_INFO: 'File to upload:',

  RESORT_MAPPING_COLUMN_PRODUCT: 'Product',

  RESORT_MAPPING_COLUMN_SEASON: 'Season',

  RESORT_MAPPING_COLUMN_AGE: 'Age',

  RESORT_MAPPING_COLUMN_FULFILLMENT_SEASON: 'Fulfillment Season',

  RESORT_MAPPING_COLUMN_PRODUCT_HEADER_CODE: 'Product Header Code',

  RESORT_MAPPING_COLUMN_ACCESS_RULE: 'Access Rule',

  RESORT_MAPPING_COLUMN_MEDIA_PRODUCT_HEADER_CODE: 'Media Product Header Code',

  RESORT_MAPPING_COLUMN_DEPARTMENT: 'Department',

  RESORT_MAPPING_COLUMN_CATEGORY: 'Category',

  RESORT_MAPPING_COLUMN_ITEM: 'Item',

  RESORT_MAPPING_COLUMN_PRODUCT_TYPE: 'Product Type',

  RESORT_MAPPING_COLUMN_WTP_RELOAD: 'WtpReload',

  RESORT_MAPPING_COLUMN_MAPPING_STATUS: 'Mapping Status',

  RESORT_MAPPING_COLUMN_HYDRATION_ERRORS: 'Hydration Errors',

  PRODUCT_MAPPING_PAGE_LOAD_ERROR: 'Unexpected error loading resort mappings.',

  PRODUCT_MAPPING_PAGE_MAPPING_STATUS_LOAD_ERROR: 'Unexpected error loading or refreshing resort mapping statuses.',

  PRODUCT_MAPPING_PAGE_HYDRATION_ERROR_LOAD_ERROR: 'Unexpected error loading product hydration errors.',

  PRODUCT_MAPPING_PAGE_SYNC_HELD: (time: string) => `Too many failed attempts. Sync is available again at ${time}.`,

  PRODUCT_MAPPING_PAGE_COLUMN_LOAD_FAILED: 'Failed to load',

  PRODUCT_MAPPING_PAGE_CELL_LOADING: 'Loading',

  PRODUCT_MAPPING_PAGE_CELL_UNAVAILABLE: 'Couldn\'t be loaded',

  PRODUCT_MAPPING_PAGE_CSV_UNAVAILABLE: 'Unavailable',

  PRODUCT_MAPPING_PAGE_SYNC_SUCCESS: 'Product mappings synchronized successfully',

  PRODUCT_MAPPING_PAGE_SAVE_ERROR_MODAL: 'Unexpected error saving resort product mappings.  Please try again later.',

  PRODUCT_MAPPING_PAGE_SAVE_ERROR: 'Unexpected error saving resort product mappings',

  PRODUCT_MAPPING_PAGE_EDIT_PRODUCTS: 'Edit Products',

  PRODUCT_MAPPING_PAGE_SAVE_PRODUCTS: 'Save Products',

  PRODUCT_MAPPING_PAGE_CANCEL_EDITS: 'Cancel Edits',

  PRODUCT_MAPPING_PAGE_SYNC: 'Sync',

  PRODUCT_MAPPING_PAGE_DOWNLOAD: 'Download',

  PRODUCT_MAPPING_PAGE_BULK_UPLOAD: 'Bulk Upload',

  PRODUCT_MAPPING_PAGE_TITLE: 'Resort Product Mapping',

  PRODUCT_MAPPING_PAGE_NOT_IMPLEMENTED: 'Function not implemented.',

  PRODUCT_MAPPING_HYDRATION_ERRORS_TOOLTIP: 'Failed hydrations! Please resolve mapping status to retry.',

  PRODUCT_MAPPING_HYDRATION_ERRORS_TOOLTIP_STATUS_LOADING: 'Failed hydrations! Retry is available once mapping status loads.',

  PRODUCT_MAPPING_HYDRATION_ERRORS_INFO_TOOLTIP: 'Resolve existing mappings status errors to retry.  Retries will be queued and can take time to reprocess.',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRY: 'Retry',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRIED: 'Retried',

  PRODUCT_MAPPING_HYDRATION_ERRORS_RETRY_SUCCESS: 'Messages have been sent to the queue for processing',

  PRODUCT_MAPPING_HYDRATION_ERROR_RETRY_FAILURE: (productName: string, fulfillmentSeason?: string, ageBin?: string) =>
     `Unexpected error occurred retrying the ${productName} ${fulfillmentSeason} ${ageBin} product hydrations. Please try again later.`,

//guest media

  ASSOC_RFID_REPRINT_MESSAGE_NO_ID: 'Guest does not have a media ID. Print a pass first.',

  ASSOC_RFID_REPRINT_MESSAGE_HAS_ID: (currentRfid: string | undefined) => `Guest already has a linked pass. Reprint to disable the current pass and link a new pass.\n\nCurrent RFID code: ${currentRfid}`,

  ASSOC_RFID_MODAL_HEADER: 'Link RFID Card',

  GUEST_LINK_RFID_LABEL: 'Link RFID',

  GUEST_LINK_RFID_INPUT_TITLE: 'Enter RFID Number',

  GUEST_LINK_RFID_INPUT_PLACEHOLDER: 'RFID Number',

  RFID_LENGTH_ERROR: 'RFID ID must be a 20 digit number. Letters and symbols are not accepted.',

  RFID_DUPLICATE_ERROR: (firstName: string, lastName: string, chipId: string) => `This RFID Code is already linked to ${firstName} ${lastName}.\nRFID: ${chipId}`,

  RFID_FORM_LABEL: 'Guest:',

  RFID_FORM_TITLE: (guestName: string) => `Link RFID for ${guestName}`,

  RFID_FORM_RETURN: 'Return to Guest Card',

  RFID_FORM_CANCEL_RFID_LINKING: 'Cancel RFID Linking',

  RFID_FORM_SUBMIT_RFID: 'Submit RFID',

  RFID_FORM_OKAY: 'Okay',

  RFID_FORM_CANCEL: 'Cancel',

  RFID_FORM_SUBMIT: 'Submit',

  MEDIA_HISTORY_MODAL_TITLE: 'Media Card History',

  MEDIA_HISTORY_MODAL_ACTIVE: 'Active',

  MEDIA_HISTORY_MODAL_INACTIVE: 'Inactive',

  MEDIA_STATUS_SELECTOR_DISABLED: 'Disabled',

  MEDIA_STATUS_SELECTOR_DEACTIVATED: 'Deactivated',

  MEDIA_HISTORY_MODAL_COLUMN_ID: 'Media Card ID',

  MEDIA_HISTORY_MODAL_COLUMN_RFID: 'RFID',

  MEDIA_HISTORY_MODAL_COLUMN_AGENT: 'Agent',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_DATE: 'Print Date',

  MEDIA_HISTORY_MODAL_COLUMN_PRINT_STATUS: 'Print Status',

  MEDIA_HISTORY_MODAL_COLUMN_RESORT: 'Resort',

  MEDIA_HISTORY_MODAL_COLUMN_STATUS: 'Status',

  MEDIA_HISTORY_MODAL_MESSAGE: 'Once a media card is disabled it cannot be re-enabled through Resort Tools',

  MEDIA_HISTORY_MODAL_CONFIRMATION: (mediaId: string | undefined) => `Are you sure you want to disable media card ${mediaId}?`,

  MEDIA_HISTORY_MODAL_DISABLE_MEDIA_SUCCESS_MESSAGE: (mediaId: string | undefined) => `Media Id ${mediaId} disabled successfully`,

  MEDIA_HISTORY_MODAL_NO_DATA: 'No media card history.',

  MEDIA_HISTORY_MODAL_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} media history. Please try again.`,

  MEDIA_HISTORY_MODAL_CANCEL: 'Cancel',

  MEDIA_HISTORY_MODAL_CONFIRM: 'Confirm',


  GROUP_PRINT_MODAL_LABEL: 'All Eligible',

  GROUP_PRINT_MODAL_GUEST_COUNT: (guestCount: number) => `Guests to Print: ${guestCount}`,

  GROUP_PRINT_MODAL_WARNING: `Once you start this print request, the guests' existing passes will no longer work.`,

  GROUP_PRINT_MODAL_CANCEL: 'Cancel',

  GROUP_PRINT_MODAL_PRINT: 'Print',

  GROUP_PRINT_MODAL_GENERATE_PDF: 'Generating PDF',

  GROUP_PRINT_MODAL_LINK_RFID: 'Link RFID:',

  GROUP_PRINT_MODAL_OKAY: 'Okay',

  GROUP_PRINT_MODAL_GROUP_LINK: 'Group Link RFID',

  GROUP_PRINT_MODAL_GROUP_PRINT: 'Group Print Pass',

  GROUP_PRINT_MODAL_FOUND_ERRORS: (errorCount) => `Found ${errorCount} errors`,

  PASS_PRINT_MODAL_NO_ACTIVE_MEDIA: 'Unable to initiate reprint, guest does not have an Active piece of media.',

  PASS_PRINT_MODAL_GENERATE_PDF: 'Generating PDF',

  PASS_PRINT_MODAL_CANCEL_TITLE: 'Cancel Printing Pass for Guest',

  PASS_PRINT_MODAL_CANCEL: 'Cancel',

  PASS_PRINT_MODAL_HEADING: 'Print Pass',

  PASS_PRINT_MODAL_OK_BTN_CLOSE: 'Close',

  PASS_PRINT_MODAL_OK_BTN_PRINT: 'Print',

  PRINT_NO_ENTITLEMENT: 'No passes to print',

  REISSUE_MEDIA_ACTION_UNKNOWN_ERROR: 'Unknown error',

  NEED_PHOTO_AND_WAIVER: 'To print a pass, ensure this guest signs a waiver and capture their photo.',
  NEED_PHOTO           : 'To print a pass, capture this guest\'s photo.',
  NEED_WAIVER          : 'To print a pass, ensure this guest signs a waiver.',

  PRINT_CONFIRMATION_1: (guestName: string) => `Are you sure you want to print a new pass for ${guestName}?`,
  PRINT_CONFIRMATION_2: 'The guest\'s existing pass will no longer work once you start the print process.',

  PRINT_NO_MEDIA: 'No active entitlements for guest',

  API_ERROR: 'Failed to generate a PDF and initiate print. Please refresh and try again.',

  PRINT_FAILURE: 'Could not open PDF. Please check your popup blocker.',

  REPRINT_APPLICABLE_FEES: 'Applicable fees:',

  GROUP_PRINT_MODAL_REPRINT_FEES: 'Reprint fees',

  REPRINT_POLICY_FLAT_RATE: (reprintFlatFee: number) => `Reprint Policy: $${reprintFlatFee} a card`,

  REPRINT_PASSES_PRINTED_SINCE: (date: string, passPrintCount: number) => `Cards printed since ${date}: ${passPrintCount}`,

  REPRINT_COUNT_LOAD_ERROR: 'Failed to load pass reprint fees.',

//guest redemption

  DTW_ENTITLEMENT_MODAL_MESSAGE: 'Once a day is redeemed it cannot be added back to the pass.',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION: 'Are you sure you want to redeem ',

  DTW_ENTITLEMENT_MODAL_CONFIRMATION_NAME: (guestName: string) => `from ${guestName} `,

  DTW_ENTITLEMENT_MODAL_CANCEL: 'Cancel',

  DTW_ENTITLEMENT_MODAL_CONFIRM: 'Confirm',

  DTW_ENTITLEMENT_MODAL_HEADING: 'Redeem Day Pass',

  DTW_ENTITLEMENT_MODAL_GUEST_LABEL: "Guest:",

  DTW_ENTITLEMENT_MODAL_PASS_LABEL: "Pass:",

  DTW_ENTITLEMENT_MODAL_NO_ITEMS: "No Passes Available",

  DTW_ENTITLEMENT_MODAL_NO_DAYS: "No Days Available",

  DTW_ENTITLEMENT_MODAL_REDEMPTION_COMPLETE: ' Redemption Complete',

  DTW_ENTITLEMENT_MODAL_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} entitlements. Please try again.`,

  DTW_ENTITLEMENT_MODAL_FAILED_REDEMPTION: (guestName: string) => `Failed to redeem ${guestName} Direct to Window days. Please try again.`,

  DTW_ENTITLEMENT_MODAL_PLURALIZED_DAY: (quantity: number) => `day${+quantity !== 1 ? 's' : ''}`,

  DTW_ENTITLEMENT_MODAL_REDEEM_LABEL: 'Redeem Date:',

  BLACKED_OUT: 'Blacked Out',

  SELECT_DATE_PLACEHOLDER: 'Select Date...',

  REDEEM_DATE_TOOLTIP: 'Enter the redemption date',

  FNF_TABLE_CONFIRMATION_REDEEM: 'Are you sure you want to redeem ',

  FNF_TABLE_CONFIRMATION_RETURN: 'Are you sure you want to return ',

  FNF_TABLE_CONFIRMATION_NAME: (days: string, possessiveGuestName: string) => ` Friends and Family ${days} from ${possessiveGuestName} `,

  FNF_TABLE_ENTITLEMENT_NAME: 'Entitlement Name',

  FNF_TABLE_DAYS_AVAILABLE: 'Days Available',

  FNF_TABLE_DAYS_USED: 'Days Used',

  FNF_TABLE_REDEEM: 'Redeem',

  FNF_TABLE_RETURN: 'Return',

  FNF_TABLE_BLACKED_OUT: 'Blacked Out',

  FNF_TABLE_ALL_USED: 'All Used',

  FNF_TABLE_NONE_USED: 'None Used',

  FNF_TABLE_NO_ENTITLEMENTS: 'No entitlements found.',

  FNF_TABLE_ACTION: 'Action',

  FNF_TABLE_EXPAND_REDEMPTION_HISTORY: 'Expand Redemption History',

  FNF_TABLE_COLLAPSE_REDEMPTION_HISTORY: 'Collapse Redemption History',

  FNF_REDEMPTION_SUMMARY_COLUMN_REDEEM_DATE: 'Redeem Date',

  FNF_REDEMPTION_SUMMARY_COLUMN_RESORT: 'Resort',

  FNF_REDEMPTION_SUMMARY_COLUMN_REF_ID: 'Ref ID',

  FNF_REDEMPTION_SUMMARY_COLUMN_TYPE: 'Type',

  FNF_REDEMPTION_SUMMARY_NO_HISTORY: 'No history',

  FNF_REDEMPTION_SUMMARY_ALL_RESORTS: 'All Resorts',

  FNF_REDEMPTION_SUMMARY_PENDING: 'Pending',

  FNF_REDEMPTION_SUMMARY_REDEMPTION: 'Redemption',

  FNF_REDEMPTION_SUMMARY_CLAIMED: 'Claimed',

  FNF_REDEMPTION_SUMMARY_SHARED: 'Shared',

  FNF_REDEMPTION_SUMMARY_SHARED_DATE: 'Shared date',

  FNF_REDEMPTION_SUMMARY_REVOKED: 'Revoked',

  FNF_REDEMPTION_SUMMARY_LABEL: 'Redemption Summary',

  FNF_REDEMPTION_SUMMARY_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} share history. Please try again.`,

  FNF_REDEMPTION_SUMMARY_REDEMPTION_ID: (redemptionId: string) => `Redemption ID: ${redemptionId}`,

  FNF_TABLE_PLURALIZED_DAY: (redeemQuantity: number) => `day${+redeemQuantity !== 1 ? 's' : ''}`,

  FNF_MODAL_REDEMPTION_COMPLETE: 'Redemption Complete',

  FNF_MODAL_RETURN_COMPLETE: 'Return Complete',

  FNF_MODAL_FAILED_LOCAL_REF: 'The local reference was not saved. Try again, or close without it.',

  FNF_MODAL_LOCAL_REF_HELD: (time: string) => `Too many failed attempts. Try again at ${time}.`,

  FNF_HISTORY_COLUMN_FROM_GUEST: 'From Guest',

  FNF_HISTORY_COLUMN_TO_GUEST: 'To Guest',

  FNF_HISTORY_COLUMN_SHARE_DATE: 'Share Date',

  FNF_HISTORY_COLUMN_CLAIM_DATE: 'Claim Date',

  FNF_HISTORY_COLUMN_REVOKE_DATE: 'Revoke Date',

  FNF_HISTORY_COLUMN_STATUS: 'Status',

  FNF_HISTORY_COLUMN_DATE: 'Date',

  FNF_HISTORY_COLUMN_RESORT: 'Resort',

  FNF_HISTORY_COLUMN_REF_ID: 'Ref ID',

  FNF_HISTORY_SHARE: 'Share History',

  FNF_HISTORY_REDEEM: 'Redemption History',

  FNF_HISTORY_GUEST_LABEL: 'Guest:',

  FNF_HISTORY_NO_HISTORY: 'No history',

  FNF_HISTORY_COPY_MGID_TO_CLIPBOARD: 'Copy Master Guest ID to clipboard',

  FNF_HISTORY_COPIED_MGID_TO_CLIPBOARD: 'Master Guest ID copied to clipboard',

  FNF_HISTORY_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} share history. Please try again`,

  FNF_MODAL_REDEEM_TAB: 'F&F Redeem',

  FNF_MODAL_HISTORY_TAB: 'History',

  FNF_MODAL_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} entitlements. Please try again.`,

  FNF_MODAL_FAILED_REDEMPTION: (guestName: string) => `Failed to redeem ${guestName} Friends and Family passes. Please try again.`,

  FNF_MODAL_ENTITLEMENT_LABEL: 'Entitlement Name:',

  FNF_MODAL_NUMBER: 'Number',

  FNF_MODAL_REDEEM_DATE: 'Redeem Date',

  FNF_SELECT_DAYS_TO_RETURN: 'Select number of days to return',

  FNF_SELECT_DAYS_TO_REDEEM: 'Select date and number of friends and family days to redeem',

  FNF_TODAY_IS_BLACKOUT_DATE: 'Today is a black out date.  Please select a date in the future that is available',

  VIEW_DAYS_VIEW_DAYS_TAB_HEADER: 'View Days',

  VIEW_DAYS_VIEW_HISTORICAL_TAB_HEADER: 'View Historical',

  VIEW_DAYS_FAILED_FETCH_ERROR: 'Failed to fetch redemption types.',

  VIEW_DAYS_HISTORY_ERROR: 'Unexpected error loading resort history.',

  VIEW_DAYS_RESORT_SELECTOR_PASS_LABEL: 'Pass: ',

  VIEW_DAYS_RESORT_SELECTOR_PASS_TITLE: 'Pass',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_LABEL: 'Resort: ',

  VIEW_DAYS_RESORT_SELECTOR_RESORT_TITLE: 'Resorts',

  VIEW_DAYS_TAB_NOT_APPLICABLE: 'N/A',

  VIEW_DAYS_TAB_COLUMN_REDEMPTION_ID: 'Redemption ID',

  VIEW_DAYS_TAB_COLUMN_TYPE: 'Type',

  VIEW_DAYS_TAB_COLUMN_DATE: 'Date',

  VIEW_DAYS_TAB_COLUMN_RESORT: 'Resort',

  VIEW_DAYS_TAB_COLUMN_MODIFIED_BY: 'Modified By',

  VIEW_DAYS_TAB_COLUMN_DAYS_USED: 'Days Used',

  VIEW_DAYS_TAB_COLUMN_NOTES: 'Notes',

  VIEW_DAYS_TAB_MODAL_HEADER: 'Correct Day Redemption',

  VIEW_DAYS_CORRECTION_BUTTON_TITLE: 'Correct Redemption',

  VIEW_DAYS_STATS_TOTAL_DAYS: 'Total Days',

  VIEW_DAYS_STATS_RESORTS: 'Resorts',

  VIEW_DAYS_STATS_MOST_VISITED: (name: string) => `Most: ${name}`,

  VIEW_DAYS_GUEST_LABEL: 'Guest:',

  VIEW_DAYS_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} resorts for this pass.`,

  VIEW_DAYS_FAILED_HISTORY: (guestName: string) => `Failed to fetch ${guestName} history for a resort. Please try again.`,

  VIEW_DAYS_NO_DATA: 'There is no history for this guest at this resort.',

  VIEW_DAYS_NO_DATA_FOUND_ERROR: 'No Data Found',

  VIEW_DAYS_UNLIMITED: 'Unlimited',

  VIEW_HISTORICAL_TAB_LOADING_DATA: 'Loading Historical Data',

  VIEW_HISTORICAL_TAB_TOTAL_DAYS: (totalDays: number) => `Total Days: ${totalDays}`,

  VIEW_HISTORICAL_TAB_REVERSE: 'Reverse',

  VIEW_HISTORICAL_TAB_MIGRATE: 'Migrate',

  VIEW_HISTORICAL_TAB_BACK: 'Back',

  VIEW_HISTORICAL_TAB_NEXT: 'Next',

  VIEW_HISTORICAL_TAB_MIGRATE_INFO: 'Select the pass you want to migrate this usage to:',

  DAY_CORRECTION_REDEMPTION_LABEL: 'Original Redemption ID:',

  DAY_CORRECTION_REDEMPTION_TITLE: 'Original Redemption ID',

  DAY_CORRECTION_REDEMPTION_BUTTON_TITLE: 'Copy Redemption ID to Clipboard',

  DAY_CORRECTION_QUANTITY_LABEL: 'Correction Quantity:',

  DAY_CORRECTION_INFO: 'Please provide a note for this negative day correction.',

  DAY_CORRECTION_NOTE_LABEL: 'Correction Note:',

  DAY_CORRECTION_INPUT: 'Correction Note',

  DAY_CORRECTION_INPUT_PLACEHOLDER: 'Guest only took one run',

  DAY_CORRECTION_BUTTON_TITLE: 'Correct Redemption & Close',

  DAY_CORRECTION_DIRECTION: 'Please review changes below and click confirm:',

  DAYS_REDEEM_NO_DAYS: `Guest doesn't have any more days to redeem`,

  DAYS_REDEEM_SELECT_TITLE: 'Redeem Days',

  DAYS_REDEEM_REDEEM: 'Redeem...',

  DAYS_REDEEM_BUTTON: 'Redeem',

  DAYS_REDEEM_NUMBER_DAYS: (i:number) => `${i} Day${i === 1 || i === -1 ? '' : 's'}`,

  PASS_CORRECTION_BUTTON_TITLE: 'Correct Redemptions and Close',

  PASS_MIGRATION_BUTTON_TITLE: 'Migrate Redemptions and Close',

  REDEMPTION_STATS_TOTAL_DAYS: 'Total Days',

  REDEMPTION_STATS_DAYS_AVAILABLE: 'Days Available',

  REDEMPTION_STATS_DAYS_USED: 'Days Used',

  REDEMPTION_HISTORY_LABEL: '10 Most Recent Uses:',

  REDEMPTION_HISTORY_DATE: 'Date',

  REDEMPTION_HISTORY_RESORT: 'Resort',

  REDEMPTION_HISTORY_REF_ID: 'Ref ID',

  REDEMPTION_HISTORY_NO_HISTORY: 'No History',

  REDEMPTION_ID_LABEL: 'Redemption ID:',

  REDEMPTION_ID_TITLE: 'Redemption ID',

  REDEMPTION_ID_BUTTON_TITLE: 'Copy Redemption ID to Clipboard',

  REDEMPTION_ID_REFERENCE_LABEL: 'Local Reference ID:',

  REDEMPTION_ID_REFERENCE_TITLE: 'Local Reference',

  REDEMPTION_ID_SAVE_BUTTON_TITLE: 'Save Local Reference & Close',

  REDEMPTION_ID_SAVE_BUTTON: 'Save & Close',

//waivers
  WAIVER_ERROR: 'error',

  WAIVER_UNKNOWN: 'unknown',

  WAIVER_ALL_FIELDS_REQUIRED: 'All fields are required.',

  WAIVER_ERROR_OVER_18: 'Guest must be 18 years of age to sign a waiver.',

  WAIVER_UNKNOWN_ERROR: 'Encountered an unknown waiver submission error',

  WAIVER_GENERIC_COMMENT: 'Stub waiver reduced in from successful submit waiver action',

  WAIVER_MODAL_LOADING: 'Loading...',

  WAIVER_MODAL_ERROR: 'Error - contact support',

  WAIVER_MODAL_UNKNOWN_TYPE: (version: number) => `Unknown Waiver Type: ${version}`,

  WAIVER_MODAL_HEADING: 'Waivers',

  WAIVER_SIGNATURE_COMPLETED_BY: 'Waiver Completed By:',

  WAIVER_SIGNATURE_FIRST_NAME_LABEL: 'First Name',

  WAIVER_SIGNATURE_FIRST_NAME_TITLE: `The signer's first name`,

  WAIVER_SIGNATURE_FIRST_NAME_INPUT: `Enter the signer's first name`,

  WAIVER_SIGNATURE_LAST_NAME_LABEL: 'Last Name',

  WAIVER_SIGNATURE_LAST_NAME_TITLE: `The signer's last name`,

  WAIVER_SIGNATURE_LAST_NAME_INPUT: `Enter the signer's last name`,

  WAIVER_SIGNATURE_DOB_LABEL: 'Date of Birth',

  WAIVER_SIGNATURE_DOB_TITLE: `The signer's birth date`,

  WAIVER_SIGNATURE_DOB_INPUT:  `Enter the signer's date of birth`,

  WAIVER_SIGNATURE_CANCEL_TITLE: 'Cancel Waiver Completion',

  WAIVER_SIGNATURE_SUBMIT_TITLE: 'Submit Completed Waiver',

  WAIVER_CANCEL: 'Cancel',

  WAIVER_SUBMIT: 'Submit',

  WAIVER_TABLE_COLUMN_WAIVER: 'Waiver',

  WAIVER_TABLE_COLUMN_WAIVER_SIGNED: 'Waiver Signed',

  WAIVER_TABLE_COLUMN_DATE_SIGNED: 'Date Signed',

  WAIVER_TABLE_UNKNOWN: 'Unknown',

  WAIVER_TABLE_UNSIGNED: 'Unsigned',

  WAIVER_TABLE_EXPIRED: (expirationDate : string | undefined) => ` (Expired: ${expirationDate})`,

  WAIVER_TABLE_SIGNED: 'Signed',

  WAIVER_TABLE_NOT_SIGNED: 'Not Signed',

  WAIVER_TABLE_NO_WAIVERS: 'No waivers found.',

  WAIVER_TABLE_GUEST_LABEL: 'Guest:',

  WAIVER_TABLE_CLICK_TO_SIGN: 'Click to Sign',

//guest card

  GUEST_CARD_DEFERRED_BANNER: 'PASS DEFERRED',

  GUEST_CARD_HOTLIST_ALL_RESORTS: 'Hotlist - All Resorts',

  GUEST_CARD_HOTLIST_RESORT: (resortName: string) => `Hotlist - ${resortName}`,

  GUEST_CARD_HOTLIST: 'Hotlist',

  GUEST_CARD_MEDIA_DISABLED: 'MEDIA DISABLED',

  GUEST_CARD_COPIED_MASTER_GUEST_ID: 'Master Guest ID copied to clipboard!',

  GUEST_CARD_COPIED_MEDIA_ID: 'Media ID copied to clipboard!',

  GUEST_CARD_FAILED_TO_LOAD: 'Failed to Load',

  GUEST_CARD_OVERFLOW_TOGGLE: 'Toggle Overflow Menu',

  GUEST_CARD_OVERFLOW_COPY_MGID: 'Copy Master Guest ID',

  GUEST_CARD_OVERFLOW_VIEW_DAYS: 'View Days',

  GUEST_CARD_OVERFLOW_GUEST_HAS_PASS: `Guest's day pass usage`,

  GUEST_CARD_OVERFLOW_GUEST_NO_PASS: `Guest has no pass for this season`,

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY: 'Media Card History',

  GUEST_CARD_OVERFLOW_MEDIA_HISTORY_TITLE: (guestName: string) => `Media History for ${guestName}`,

  GUEST_CARD_OVERFLOW_PUT_HOTLIST: 'Put this guest on the hotlist',

  GUEST_CARD_OVERFLOW_ALREADY_HOTLISTED: 'All guest passes are already hotlisted',

  GUEST_CARD_OVERFLOW_NO_PASS_HOTLIST: 'Guest has no pass to be hotlisted',

  GUEST_CARD_OVERFLOW_HOTLIST: 'Add to Hotlist',

  GUEST_CARD_OVERFLOW_VIEW_COMMENTS: 'View Comments',

  GUEST_CARD_OVERFLOW_TAKE_HOTLIST: 'Take this guest off the hotlist',

  GUEST_CARD_OVERFLOW_REMOVE_HOTLIST: 'Remove from hotlist',

  GUEST_CARD_OVERFLOW_COMMENT_HISTORY: (guestName: string) => `Comment History for ${guestName}`,

  GUEST_CARD_OVERFLOW_ADD_COMMENT: 'Add Comment',

  GUEST_CARD_OVERFLOW_ADD_COMMENT_TITLE: (guestName: string) => `Add a comment for ${guestName}`,

  GUEST_PROFILE_YEARS_OLD: (age: number) => `${age} years old`,

  GUEST_PROFILE_NO_DOB: 'No Birth Date',

  GUEST_PROFILE_TOOLTIP: 'Pass Photo',

  GUEST_PROFILE_DISABLED_TOOLTIP: 'Guest is hotlisted.',

  GUEST_PROFILE_COPY_MGID_TO_CLIPBOARD: 'Copy Master Guest ID to clipboard',

  PASS_OVERVIEW_NO_MEDIA: 'No Media ID',

  PASS_OVERVIEW_TITLE: 'IKON Media ID (same as barcode number when printed)',

  PASS_OVERVIEW_COPY_BUTTON: 'Copy Media ID to Clipboard',

  PASS_OVERVIEW_SEASON: 'Season',

  PASS_OVERVIEW_NAME: 'Name',

  PASS_OVERVIEW_NO_PASSES: 'No Active Passes',

  PASS_OVERVIEW_NO_ENTITLEMENTS: 'No Pass Entitlements',

  PASS_OVERVIEW_LOADING_VALID_LOCATIONS: 'Loading valid locations…',

  PASS_OVERVIEW_VALID_LOCATIONS_ERROR: 'Unable to load valid locations',

  PASS_OVERVIEW_NO_VALID_LOCATIONS: 'No valid locations found',

  PASS_OVERVIEW_RESTRICTED_PREFIX: 'Only valid at:',

  PRIMARY_ACTIONS_PRINT_CARD: 'Print Card',

  PRIMARY_ACTIONS_LINK_CARD: 'Link RFID Card',

  PRIMARY_ACTIONS_WAIVER_SIGNED: 'Guest Waiver is Signed',

  PRIMARY_ACTIONS_WAIVER_SIGNATURE: 'Click to record a waiver signature',

  SECONDARY_ACTIONS_REDEEM_PASS: 'View & Redeem Day Pass',

  SECONDARY_ACTIONS_REDEEM_FNF: 'View & Redeem Friends and Family Day Pass',

  SECONDARY_ACTIONS_IMPORT_TOOLTIP: 'Import Guest Record',

//guest comments

  ADD_COMMENT_GUEST_LABEL: 'Guest:',

  ADD_COMMENT_SUBJECT_LABEL: 'Subject',

  ADD_COMMENT_COMMENTS_LABEL: 'Comments',

  ADD_COMMENT_CHARACTER_INFO: (minChars: number, maxChars: number) => `(${minChars} to ${maxChars} characters)`,

  ADD_COMMENT_ADD_COMMENT: 'Add Comment',

  ADD_COMMENT_BUTTON_TITLE: (guestName: string) => `Add Comment to ${guestName}`,

  ADD_COMMENT_ERROR: 'Unexpected error adding a new guest comment.',

  COMMENT_HISTORY_COLUMN_DATE: 'Date',

  COMMENT_HISTORY_COLUMN_AGENT: 'Agent',

  COMMENT_HISTORY_COLUMN_SUBJECT: 'Subject',

  COMMENT_HISTORY_COLUMN_COMMENT: 'Comment',

  COMMENT_HISTORY_NO_HISTORY: 'This guest has no comment history.',

  COMMENT_HISTORY_FAILED_FETCH: (guestName: string) => `Failed to fetch ${guestName} comment history. Please try again.`,

  COMMENT_NO_SUBJECT: 'A subject is required.',

  COMMENT_NO_COMMENT: 'A comment of 10 to 500 characters is required.',

  COMMENT_HISTORY_FETCH_ERROR: `Unexpected error fetching guest's comment history.`,

  COMMENT_HISTORY_VIEW_COMMENTS: 'View Comments',

//guest contact

  ADDRESS_NO_ADDRESS_TITLE: `This guest doesn't have an address`,

  ADDRESS_NO_ADDRESS: 'No Address',

  ADDRESS_NO_DATA: 'No Data',

  ADDRESS_LINE_ONE: 'Address Line 1',

  ADDRESS_LINE_TWO: 'Address Line 2',

  ADDRESS_CITY: 'City',

  ADDRESS_NO_CITY: 'No City, ',

  ADDRESS_STATE: 'State',

  ADDRESS_NO_STATE: 'No State',

  ADDRESS_POSTAL: 'Postal Code',

  ADDRESS_NO_POSTAL: 'No Postal Code, ',

  ADDRESS_COUNTRY: 'Country',

  ADDRESS_NO_COUNTRY: 'No Country',

//guest photo

  GUEST_PHOTO_MODAL_HEADING: 'Capture Photo',

  GUEST_PHOTO_GUEST_LABEL: 'Guest:',

//hotlist

  HOTLIST_ADD_HOTLIST: 'Add to Hotlist',

  HOTLIST_PUT_HOTLIST: (guestName: string) => `Put ${guestName} on hotlist`,

  HOTLIST_NO_ENTITLEMENT: 'A pass must be selected to add to hotlist.',

  HOTLIST_NO_RESORT: 'A resort must be selected.',

  HOTLIST_NO_REASON: 'A reason is required to add to hotlist.',

  HOTLIST_NO_COMMENT: 'A comment of 10 to 500 characters is required.',

  HOTLIST_INVALID_EFF_DATE: 'A valid start date is required to add to hotlist.',

  HOTLIST_INVALID_EXP_DATE: 'A valid end date is required to add to hotlist.',

  HOTLIST_PREDATED_EFF_DATE: 'Hotlisting must take effect either today or in the future',

  HOTLIST_EXPIRES_EFF_DATE: 'Hotlisting must expire on or after start date.',

  HOTLIST_MODAL_NO_PASS_SELECTED: 'No pass selected',

  HOTLIST_MODAL_GUEST_LABEL: 'Guest:',

  HOTLIST_MODAL_PASS_LABEL: 'Pass',

  HOTLIST_MODAL_PASS_PLACEHOLDER: 'Pass...',

  HOTLIST_MODAL_FAILED_ENTITLEMENTS: 'Failed to load entitlements',

  HOTLIST_MODAL_RESORT_LABEL: 'Resort',

  HOTLIST_MODAL_REPORTER_CONTACT_NUMBER: 'Reporter Contact Number',

  HOTLIST_COMMENT_WITH_REPORTER_CONTACT: (phoneNumber: string, comment: string) => `Reporter Contact Number: ${phoneNumber} - ${comment}`,

  HOTLIST_MODAL_DIRECT_LINE: 'Direct Line',

  HOTLIST_MODAL_ENTER_PHONE_NUMBER: 'Enter phone number',

  HOTLIST_MODAL_PHONE_EXTENSION: 'Ext.',

  HOTLIST_MODAL_PHONE_NUMBER_REQUIRED: 'The reporter contact phone number format has an extension but the phone number is missing',

  HOTLIST_MODAL_INVALID_PHONE_NUMBER_FORMAT: 'The reporter contact number format is invalid',

  HOTLIST_MODAL_COMMENT_GUIDANCE: 'Include detailed incident description and next steps for guest follow up...',

  HOTLIST_MODAL_FAILED_TO_LOAD_RESORTS: 'Failed to load resorts.',

  HOTLIST_MODAL_RESORT_PLACEHOLDER: 'Resort...',

  HOTLIST_MODAL_FROM_LABEL: 'From',

  HOTLIST_MODAL_STARTING_DATE_PLACEHOLDER: 'Starting Date...',

  HOTLIST_MODAL_STARTING_DATE_TOOLTIP: 'Enter the starting date for hotlisted status',

  HOTLIST_MODAL_TO_LABEL: 'To',

  HOTLIST_MODAL_ENDING_DATE_PLACEHOLDER: 'Ending Date...',

  HOTLIST_MODAL_ENDING_DATE_TOOLTIP: 'Enter the ending date for hotlisted status',

  HOTLIST_MODAL_REASON: 'Reason for Hotlist',

  HOTLIST_MODAL_REASON_PLACEHOLDER: 'Reason...',

  HOTLIST_MODAL_REASON_FAILED: 'Failed to load reasons',

  HOTLIST_MODAL_HOTLIST_LABEL: 'Hotlist:',

  HOTLIST_MODAL_COMMENTS_LABEL: 'Comments',

  HOTLIST_MODAL_CANCEL: 'Cancel',

  HOTLIST_MODAL_CHARACTER_INFO: (minChars: number, maxChars: number) => `(${minChars} to ${maxChars} characters)`,

  HOTLIST_TABLE_HOTLIST: 'Hotlist',

  HOTLIST_TABLE_DURATION: 'Duration',

  HOTLIST_TABLE_COMMENT: 'Comment',

  HOTLIST_TABLE_REMOVE: 'Remove From Hotlist',

  HOTLIST_TABLE_UNTIL_EXPIRATION: (date: string) => `Until ${date}`,

  HOTLIST_TABLE_INDEFINITE: 'Indefinite',

  HOTLIST_TABLE_GUEST_LABEL: 'Guest:',

  HOTLIST_TABLE_NO_HOTLIST: 'There are no active hotlists for this guest',

  HOTLIST_REMOVE_MODAL_HEADING: 'Remove from Hotlist',

  HOTLIST_REMOVE_MODAL_SUBMIT_TITLE: (guestName: string) => `Take ${guestName} off hotlist`,

  HOTLIST_REMOVE_MODAL_CANCEL_BUTTON: 'Cancel removing from Hotlist',

  FEATURE_DISABLING_LOADING_GUEST: 'Loading guest...',

  FEATURE_DISABLING_NO_PASS: `Guest doesn't have a pass for this season.`,

  FEATURE_DISABLING_DEFERRED: 'Guest is using a deferred pass and cannot redeem entitlements at this time.',

  FEATURE_DISABLING_HOTLISTED: 'Guest is hotlisted and cannot redeem entitlements at this time.',

  FEATURE_DISABLING_WAIVER: 'Guest must sign a waiver first',

  FEATURE_DISABLING_NO_FNF: 'Guest has no friends and family vouchers for this resort.',

  FEATURE_DISABLING_NOT_AVAILABLE: 'This feature is not available at your resort',

  FEATURE_DISABLING_GUEST_IMPORTED: 'Guest is already imported.',

  GUEST_SNACKBAR_FAILED_PHOTO_LOAD: (guestName: string) => `Failed to load photo for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_PHOTO_SET: (guestName: string) => `Failed to set photo for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_HOTLIST: (guestName: string) => `Failed to load hotlist details for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_PASSES: (guestName: string) => `Failed to load passes for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_LINK: (guestName: string) => `Failed to link pass for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_SUBMIT_WAIVER: (guestName: string) => `Failed to submit waiver for ${guestName}. Please try again.`,

  GUEST_SNACKBAR_FAILED_SUBMIT_REFERENCE: (guestName: string) => `Failed to submit local reference for ${guestName}.`,

  GUEST_SNACKBAR_FAILED_IMPORT: (guestName: string, msg: string) => `Failed to import ${guestName}.\n${msg}`,

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT: (firstName: string, lastName: string) => `${firstName} ${lastName} was successfully imported.`,

  GUEST_SNACKBAR_SUCCESSFUL_IMPORT_WITH_ENTITLEMENT_ERROR: (firstName: string, lastName: string, entitlementErrorCount: number) => `${firstName} ${lastName} was successfully imported.\n${entitlementErrorCount} entitlement(s) were not imported.`,

// Group Search
  GROUP_MENU_GROUP: (NumberInGroup) => `Group (${NumberInGroup})`,

  GROUP_MENU_CLOSE_ACTIONS : 'Close Group Actions Menu',

  GROUP_MENU_EXPAND_GROUP: 'Expand the group to take a group action',

  GROUP_MENU_OPEN_GROUP_ACTIONS: 'Open Group Actions Menu',

  GROUP_MENU_NO_GUESTS_CAN_BE_PRINTED: 'No guests can be printed at this time',

  GROUP_MENU_PRINT_PASSES: 'Print passes for the household',

  GROUP_MENU_NO_GUESTS_ELIGIBLE_FOR_IMPORT: 'No guests are eligible for import',

  GROUP_MENU_IMPORT_ALL_HOUSEHOLD: 'Import all eligible household members',

  GROUP_MENU_IMPORTING_GROUP: 'Importing group...',

  GROUP_MENU_PRINT_GROUP:  'Print Group',

  GROUP_MENU_IMPORT_GROUP: 'Import Group',

  HORIZONTAL_GUEST_DETAIL_FIRST_NAME: 'First Name',

  HORIZONTAL_GUEST_DETAIL_NO_FIRST_NAME: 'No First Name',

  HORIZONTAL_GUEST_DETAIL_LAST_NAME: 'Last Name',

  HORIZONTAL_GUEST_DETAIL_NO_LAST_NAME: 'No Last Name',

  HORIZONTAL_GUEST_DETAIL_YEARS_OLD: (Age) => `${Age} years old`,

  HORIZONTAL_GUEST_DETAIL_NO_BIRTH_DATE: 'No Birth Date',

  HORIZONTAL_GUEST_DETAIL_PRIMARY_EMAIL: 'Primary Email',

  HORIZONTAL_GUEST_DETAIL_NO_EMAIL: 'No Email Address',

  HORIZONTAL_GUEST_DETAIL_PHONE_NUMBER: 'Primary Phone Number',

  HORIZONTAL_GUEST_DETAIL_NO_PHONE_NUMBER: 'No Phone Number',

  GUEST_SEARCH_RESULT_UNEXPECTED_ERROR: 'An unexpected error occurred while loading household. Please try again later.',

  GUEST_SEARCH_RESULT_HIDE_GUESTS: 'Hide Guests',

  GUEST_SEARCH_RESULT_VIEW_GUESTS: 'View Guests',

  GUEST_SEARCH_RESULTS_NO_ACCOUNTS_MATCH: 'No accounts match ',

  GUEST_SEARCH_RESULTS_PLEASE_SEARCH_AGAIN: ', please search again.',

  GUEST_SEARCH_BOX_BLACKLISTED: 'Warning: Blacklisted Search Term',

  GUEST_SEARCH_MIN_LENGTH: (MinSearchLength) => `Warning: ${MinSearchLength} Character Search Minimum`,

  GUEST_SEARCH_IKON_GUEST: 'Search for an IKON guest',

  GUEST_SEARCH_SEARCH: 'Search',

  GUEST_SEARCH_PLACEHOLDER: 'Find a Guest',

  GUEST_SEARCH_TOP_ACCOUNT_MATCH: 'Top account matching ',

  GUEST_SEARCH_TOP_ACCOUNTS_MATCH: (NumberAccounts) => `Top ${NumberAccounts} accounts matching `,

  GUEST_SEARCH_SORT_BY: 'Sort By: ',

  GUEST_SORT_MENU_CLOSE: 'Close Sort Menu',

  GUEST_SORT_MENU_OPEN: 'Open Sort Menu',

  GUEST_SORT_RELEVANCE: 'Relevance',

  GUEST_SORT_LAST_NAME_A_Z: 'Last Name (A - Z)',

  GUEST_SORT_LAST_NAME_Z_A: 'Last Name (Z - A)',

  GUEST_SORT_AGE_0_100: 'Age (0 - 100)',

  GUEST_SORT_AGE_100_0: 'Age (100 - 0)',

// PassResortSelector
  PASS_RESORT_SELECTOR_NO_PASSES: 'No passes',

  PASS_RESORT_SELECTOR_PASSES: 'Passes',

  PASS_RESORT_SELECTOR_NO_RESORTS: 'No Resorts',

  PASS_RESORT_SELECTOR_RESORTS: 'Resorts',


  //RTP Script Version
  RTP_SCRIPT_VERSION: 'Script Versions:',

  GET_SCRIPT_VERSION_ACTION_ERROR: 'Something went wrong fetching rtp script versions',

  //Search History
  GET_SEARCH_HISTORY_ACTION_ERROR: 'Something went wrong fetching user search history',

  CLEAR_SEARCH_HISTORY_ACTION_ERROR: 'Something went wrong clearing user search history',

  SEARCH_HISTORY_RESULTS: 'Search Results:',

  SEARCH_HISTORY_TITLE: 'Search History:',

  SEARCH_HISTORY_CLEAR:  'Clear History',

  // Reports Page
  REPORTS_TITLE: 'Reports',
  REPORTS_PAGE_INFO: 'Run reports based on Resort Tools activity.',
  REPORTS_GUEST_HYDRATION_ERRORS: 'Guest Hydration Errors',
  REPORTS_GUEST_HYDRATION_ERRORS_MODAL_HEADER: 'Guest Hydration Errors',
  GET_GUEST_HYDRATION_ERRORS_ACTION_ERROR: 'Something went wrong fetching guest hydration errors',
  GUEST_HYDRATION_ERRORS_RETRIED: 'Retried',
  GUEST_HYDRATION_ERRORS_RETRY: 'Retry',
  GUEST_HYDRATION_ERRORS_TOOLTIP: 'Failed hydrations! Please resolve guest errors to retry.',
  GUEST_HYDRATION_REPORT_COPIED_MASTER_GUEST_ID: 'Master Guest ID copied to clipboard',
  GUEST_HYDRATION_REPORT_COPY_MASTER_GUEST_ID: 'Copy Master Guest ID to clipboard',
  GUEST_HYDRATION_REPORT_MGID: 'Master Guest ID',
  GUEST_HYDRATION_REPORT_HYDRATION_ERROR: 'Hydration Error',
  GUEST_HYDRATION_REPORT_HYDRATION_DATE: 'Most Recent Hydration Attempt',
  GUEST_HYDRATION_REPORT_SEARCH_LABEL: 'Search By Guest ID:',
  GUEST_HYDRATION_ERRORS_REPLAY_FAILURE: (masterGuestId: string, resortAbbrev: string) => `Unexpected error occurred retrying the guest hydration for ${masterGuestId} at ${resortAbbrev}. Please try again later.`,
  GUEST_HYDRATION_ERRORS_REPLAY_SUCCESS: 'Messages have been sent to the queue for processing',
  GET_GUEST_HYDRATION_ERRORS_COUNT_ACTION_ERROR: 'Something went wrong fetching guest hydration error count',
  GUEST_HYDRATION_ERRORS_DAYS_LABEL: 'Days of history:',
  GUEST_HYDRATION_ERRORS_GUESTS_PER_PAGE: 'Guests per page:',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE: 'Close',
  REPORTS_GUEST_HYDRATION_ERRORS_CLOSE_TITLE: 'Close Guest Hydration Errors Report',
  REPORTS_GUEST_HYDRATION_ERRORS_NO_ERRORS_TOOLTIP: 'No Guest Hydration Errors found.',
  REPORTS_HOTLIST_REPORT: 'Hotlist Report',
  REPORTS_EXPORT_HOTLIST_REPORT: 'Export Hotlist Report',
  REPORTS_EXPORT_REPORT: 'Export Report',
  REPORTS_HOTLIST_REASON: 'Reason for Hotlist',
  REPORTS_HOTLIST_REASON_PLACEHOLDER: 'Reason...',
  REPORTS_HOTLIST_REASON_FAILED: 'Failed to load reasons',
  REPORTS_HOTLIST_FROM_LABEL: 'From',
  REPORTS_HOTLIST_FROM_DATE_TOOLTIP: 'Enter the From date for the hotlist report',
  REPORTS_HOTLIST_TO_LABEL: 'To',
  REPORTS_HOTLIST_TO_DATE_TOOLTIP: 'Enter the To date for the hotlist report',
  REPORTS_HOTLIST_NO_REASON: 'A reason is required for the hotlist report.',
  REPORTS_HOTLIST_INVALID_FROM_DATE: 'A valid From date is required for the hotlist report.',
  REPORTS_HOTLIST_INVALID_TO_DATE: 'A valid To date is required for the hotlist report.',
  REPORTS_HOTLIST_FROM_BEFORE_TO_DATE: 'To date must be on or after From date.',
  REPORTS_HOTLIST_DATE_RANGE_MAX: 'Date range too large. The maximum date range for the hotlist report is 1 year.',
  REPORTS_HOTLIST_ERROR_GENERATING_CSV_FILE: 'Something went wrong generating the csv file.',
  REPORTS_HOTLIST_ERROR_DOWNLOAD_FAILED: 'Failed to download hotlist report.',
  REPORTS_HOTLIST_CREATED_DATE: 'Created Date',
  REPORTS_HOTLIST_NARROW_SEARCH_PARAMS: 'Too much data. Please narrow your search parameters.',
  REPORTS_HOTLIST_ERROR_NO_DATA: 'No hotlist data found for the current search parameters.',
  REPORTS_HOTLIST_REQUEST_CANCELLED: 'Request was canceled. Please try again.',
  REPORTS_HOTLIST_INVALID_PARAMETERS: 'Invalid request parameters.',
  REPORTS_WEEKLY_VISTOR_DATA: 'Weekly Visitor Data',
  REPORTS_CLOSE: 'Close',
  REPORTS_WEEKLY_VISITOR_DATA_CLOSE_TITLE: 'Close Weekly Visitor Data Reports',
  REPORTS_WEEKLY_VISITOR_ERROR_LOADING: 'Failed to load Weekly Visitor Data Reports',
  REPORTS_WEEKLY_VISITOR_REPORT_DOWNLOAD_ERROR: (reportName: string) => `Error downloading report ${reportName}`,
  REPORTS_WEEKLY_VISITOR_REPORT_NONE_FOUND: 'No Weekly Visitor Data reports found',
  REPORTS_DOWNLOADING: 'Downloading...',

  PRODUCT_ADMIN_PAGE_TITLE: 'Product Administration',
  PRODUCT_ADMIN_PAGE_INFO: 'Manage Product, Global and Access details for all resorts',
  PRODUCT_ADMIN_OPEN_NAVIGATION_PANEL: 'Open Navigation Panel',
  PRODUCT_ADMIN_CLOSE_NAVIGATION_PANEL: 'Close Navigation Panel',
  PRODUCT_ADMIN_PRODUCT: 'Product',
  PRODUCT_ADMIN_ACCESS: 'Access',
  PRODUCT_ADMIN_ACCESS_OVERVIEW: 'Overview',
  PRODUCT_ADMIN_GLOBAL: 'Global',

  ACCESS_OVERVIEW_SEARCH: 'SEARCH',
  ACCESS_OVERVIEW_SEARCH_TITLE: 'Search for access products',
  ACCESS_OVERVIEW_OR: 'or',
  ACCESS_OVERVIEW_SEASON: 'Season',
  ACCESS_OVERVIEW_FULFILLMENT_SEASON: 'Fulfillment Season',
  ACCESS_OVERVIEW_LOCATION: 'Location',
  ACCESS_OVERVIEW_LOADING_SELLING_SEASONS_ERROR: 'Something went wrong loading selling seasons',
  ACCESS_OVERVIEW_LOADING_FULFILLMENT_SEASONS_ERROR: 'Something went wrong loading fulfillment seasons',
  ACCESS_OVERVIEW_LOADING_RESORT_DETAILS_ERROR: 'Something went wrong loading resort details',
  ACCESS_OVERVIEW_LOADING_ACCESS_PRODUCTS_ERROR: 'Something went wrong loading access products',
  ACCESS_OVERVIEW_ID: 'ID',
  ACCESS_OVERVIEW_DESCRIPTION: 'Description',
  ACCESS_OVERVIEW_DESCRIPTION_PLACEHOLDER: 'Enter description keyword...',
  ACCESS_OVERVIEW_ID_PLACEHOLDER: 'Enter comma separated IDs...',
  ACCESS_OVERVIEW_CLEAR: 'Clear',
  ACCESS_OVERVIEW_EXPAND_ALL: 'Expand All',
  ACCESS_OVERVIEW_COLLAPSE_ALL: 'Collapse All',
  ACCESS_OVERVIEW_SELECT_ALL: 'Select All',
  ACCESS_OVERVIEW_FILTERED_SELECT: ' (filtered)',
  ACCESS_OVERVIEW_NUMBER_SELECTED: (numberSelected: number) => `${numberSelected} selected`,
  ACCESS_OVERVIEW_REQUIRED: 'Required',
  ACCESS_OVERVIEW_SEARCH_PLACEHOLDER: 'Search...',
  ACCESS_OVERVIEW_CLEAR_SEARCH: 'Clear Search',
  ACCESS_OVERVIEW_CLEAR_SELECTION: 'Clear Selection',
  ACCESS_OVERVIEW_NUMBER_SHOWN: (numberShown: number) => ` · ${numberShown} shown`,
  ACCESS_OVERVIEW_NO_OPTIONS: 'No options',
  ACCESS_OVERVIEW_SELECTED_TITLE: (selectedLabels: string) => `Selected: ${selectedLabels}`,
  ACCESS_OVERVIEW_SEARCH_WITH_TEXT_TITLE: (text: string) => `Search: ${text}`,
  ACCESS_OVERVIEW_DIGITS_COMMAS_SPACES_ERROR: 'Only digits, commas, and spaces are allowed.',
  ACCESS_OVERVIEW_INVALID_ID_ERROR: 'One or more IDs are invalid.',
  ACCESS_OVERVIEW_INVALID_ID_LIST_ERROR: 'Only comma-separated integer IDs are allowed.',
  ACCESS_OVERVIEW_MAX_IDS_ERROR: (maxIds: number) => `A maximum of ${maxIds} IDs are allowed.`,
  ACCESS_OVERVIEW_VALIDATION_PREFIX: 'Please select values for ',
  ACCESS_OVERVIEW_AND: 'and',
  ACCESS_OVERVIEW_ROWS_PER_PAGE: 'Rows per page:',
  ACCESS_OVERVIEW_NO_ACCESS_DATA: 'No access products found for the current filter.',
  ACCESS_OVERVIEW_SET_FILTERS: 'Please select at least one filter.',
  ACCESS_OVERVIEW_CLICK_SEARCH: 'Click search to load access products.',
  ACCESS_OVERVIEW_RESULT_LIMIT_EXCEEDED: (maxResults: number) => `Result limit of ${maxResults} exceeded. Please refine your search criteria.`,
  LIFT_ACCESS_RULES_TABLE_ID: 'ID',
  LIFT_ACCESS_RULES_TABLE_ENTITLEMENT_TYPE_ID: 'Entitlement Type ID',
  LIFT_ACCESS_RULES_TABLE_DESCRIPTION: 'Description',
  LIFT_ACCESS_RULES_TABLE_ENTITLEMENT_DESCRIPTION: 'Entitlement Description',
  LIFT_ACCESS_RULES_TABLE_SEASON: 'Season',
  LIFT_ACCESS_RULES_TABLE_FULFILLMENT_SEASON: 'Fulfillment Season',
  LIFT_ACCESS_RULES_TABLE_LOCATION: 'Location',
  LIFT_ACCESS_RULES_TABLE_EFFECTIVE_DATE: 'Start',
  LIFT_ACCESS_RULES_TABLE_SEASON_EFFECTIVE_DATE: 'Season Effective Date',
  LIFT_ACCESS_RULES_TABLE_EXPIRATION_DATE: 'End',
  LIFT_ACCESS_RULES_TABLE_SEASON_EXPIRATION_DATE: 'Season Expiration Date',
  LIFT_ACCESS_RULES_TABLE_EFFECTIVE_TIME: 'Time',
  LIFT_ACCESS_RULES_TABLE_SEASON_EFFECTIVE_TIME: 'Season Effective Time',
  LIFT_ACCESS_RULES_TABLE_MAX_DAYS: 'Max Days',
  LIFT_ACCESS_RULES_TABLE_BLACKOUT: 'Black Out',
  LIFT_ACCESS_RULES_TABLE_BLACKOUT_DATE_RANGES: 'Black Out Date Ranges',
  LIFT_ACCESS_RULES_TABLE_BLACKOUT_DOW: 'DOW',
  LIFT_ACCESS_RULES_TABLE_BLACKOUT_DAYS_OF_WEEK: 'Black Out Days of Week',
  LIFT_ACCESS_RULES_TABLE_SHARED: 'Shared',
  DAY_OF_WEEK_SUN: 'Sun',
  DAY_OF_WEEK_MON: 'Mon',
  DAY_OF_WEEK_TUE: 'Tue',
  DAY_OF_WEEK_WED: 'Wed',
  DAY_OF_WEEK_THU: 'Thu',
  DAY_OF_WEEK_FRI: 'Fri',
  DAY_OF_WEEK_SAT: 'Sat',
  SHORT_DAY_OF_WEEK_SUN: 'Su',
  SHORT_DAY_OF_WEEK_MON: 'Mo',
  SHORT_DAY_OF_WEEK_TUE: 'Tu',
  SHORT_DAY_OF_WEEK_WED: 'We',
  SHORT_DAY_OF_WEEK_THU: 'Th',
  SHORT_DAY_OF_WEEK_FRI: 'Fr',
  SHORT_DAY_OF_WEEK_SAT: 'Sa',
  ACCESS_RULE_EDIT_MODAL_TITLE: 'Access Rule Edit',
  ACCESS_RULE_MODAL_SAVE: 'Save',
  ACCESS_RULE_MODAL_SAVE_TITLE: 'Save Access Rule Changes',
  ACCESS_RULE_MODAL_CANCEL: 'Cancel',
  ACCESS_RULE_MODAL_CANCEL_TITLE: 'Cancel and exit without saving changes',
  ACCESS_RULE_EDIT_ID: 'ID:',
  ACCESS_RULE_EDIT_ENTITLEMENT_TYPE_ID: 'Entitlement Type ID:',
  ACCESS_RULE_EDIT_SEASON: 'Season:',
  ACCESS_RULE_EDIT_SELLING_SEASON: 'Selling Season:',
  ACCESS_RULE_EDIT_FULFILLMENT_SEASON: 'Fulfillment Season:',
  ACCESS_RULE_EDIT_LOCATION: 'Location:',
  ACCESS_RULE_EDIT_DESCRIPTION: 'Description:',
  ACCESS_RULE_EDIT_EFFECTIVE_DATE_RANGE: 'Effective Date Range',
  ACCESS_RULE_EDIT_DATE_START: 'Start Date',
  ACCESS_RULE_EDIT_DATE_EXPIRE: 'Expire Date',
  ACCESS_RULE_EDIT_DATE_END: 'End Date',
  ACCESS_RULE_EDIT_EFFECTIVE_TIME_RANGE: 'Effective Time Range',
  ACCESS_RULE_EDIT_TIME_START: 'Start Time',
  ACCESS_RULE_EDIT_TIME_END: 'End Time',
  ACCESS_RULE_EDIT_MAX_DAYS: 'Max Days',
  ACCESS_RULE_EDIT_MAX_DAYS_INFO: 'Blank Max Days means usage is unlimited',
  ACCESS_RULE_EDIT_MAX_DAYS_SHARED: 'Shared',
  ACCESS_RULE_EDIT_BLACKOUT_DOW: 'Black Out DOW',
  ACCESS_RULE_EDIT_MISSING_REQUIRED_FIELD: 'Warning! A required field is blank.  Pass will not validate without required fields',
  ACCESS_RULE_EDIT_RULE_ID: (ruleId: number) => `Rule ID: ${ruleId}`,
  ACCESS_RULE_EDIT_REQUIRED: 'Required',
  ACCESS_RULE_EDIT_EFFECTIVE_START_AND_EXPIRATION_REQUIED: 'Both a valid start date and a valid expire date are required',
  ACCESS_RULE_EDIT_EFFECTIVE_START_DATE_REQUIRED: 'A valid start date is required',
  ACCESS_RULE_EDIT_EFFECTIVE_END_DATE_REQUIRED: 'A valid expire date is required',
  ACCESS_RULE_EDIT_EFFECTIVE_START_AFTER_END: 'The product must expire on or after start date',
  ACCESS_RULE_EDIT_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The start date must be within one year of the season start date',
  ACCESS_RULE_EDIT_EFFECTIVE_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The start date must be less than the season end date',
  ACCESS_RULE_EDIT_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_END: 'The expire date must be wihin one year of the season end date',
  ACCESS_RULE_EDIT_EXPIRATION_DATE_OUTSIDE_ONE_YEAR_OF_SEASON_START: 'The expire date must be greater than the season start date',
  ACCESS_RULE_EDIT_EFFECTIVE_DATE_OUTSIDE_SEASON_START: 'Warning: The start date is outside the season start date',
  ACCESS_RULE_EDIT_EXPIRATION_DATE_OUTSIDE_SEASON_END: 'Warning: The expire date is outside the season end date',
  ACCESS_RULE_EDIT_UNKNOWN_VALIDATION_ERROR: 'Unknown date validation error',
  ACCESS_RULE_DELETE: 'Delete',
  ACCESS_RULE_BULK_DELETE_CONFIRM_TITLE:
    'Permanently delete the selected access rules and all their rules',
  ACCESS_RULE_EDIT: 'Edit',
  ACCESS_RULE_OPTIONS: 'Options',

  ACCESS_RULE_SELECT_ROW: 'Select rule set',
  // Names the scope: the toggle selects every search result, not just the rows
  // on the current page.
  ACCESS_RULE_SELECT_ALL_RESULTS: (count: number) =>
    `Select all ${count} result${count === 1 ? '' : 's'}`,
  // Says what the label can't: the toggle reaches past the current page.
  ACCESS_RULE_SELECT_ALL_RESULTS_TITLE:
    'Select every rule set the search returned, including those on pages not shown',
  ACCESS_RULE_CLEAR_SELECTION: 'Clear',
  ACCESS_RULE_CLEAR_SELECTION_TITLE: (count: number) =>
    `Deselect the ${count} selected rule set${count === 1 ? '' : 's'}`,
  ACCESS_RULE_EDIT_SELECTED: 'EDIT SELECTED',
  ACCESS_RULE_EDIT_SELECTED_TITLE: 'Edit selected access rules',
  ACCESS_RULE_DELETE_SELECTED: 'DELETE SELECTED',
  ACCESS_RULE_DELETE_SELECTED_TITLE: 'Delete selected access rules',

  ACCESS_RULE_BULK_EDIT_MODAL_TITLE: 'Bulk Edit Access Rules',
  ACCESS_RULE_BULK_EDIT_AFFECTED: (count: number) =>
    `${count} rule set${count === 1 ? '' : 's'} selected`,
  ACCESS_RULE_BULK_EDIT_APPLY_MODE: 'For each rule category, choose how to apply your changes to the selected rule sets. Only the categories you switch to Add or Replace can be edited below.',
  ACCESS_RULE_BULK_MODE_UNCHANGED: 'Leave unchanged',
  ACCESS_RULE_BULK_MODE_ADD: 'Add to existing',
  ACCESS_RULE_BULK_MODE_REPLACE: 'Replace existing',
  ACCESS_RULE_BULK_MODE_CLEAR: 'Delete all',
  // Contextual effect captions shown under the selected mode for a category.
  ACCESS_RULE_BULK_MODE_ADD_HINT: 'Keeps existing rules and adds the rules below to every selected rule set.',
  ACCESS_RULE_BULK_MODE_REPLACE_HINT: (count: number) =>
    `Deletes all existing rules in this category on the ${count} selected rule set${count === 1 ? '' : 's'}, then adds the rules below.`,
  ACCESS_RULE_BULK_MODE_REPLACE_HINT_SINGLETON: (count: number) =>
    `Overwrites the existing rule on the ${count} selected rule set${count === 1 ? '' : 's'} with the one below.`,
  ACCESS_RULE_BULK_MODE_CLEAR_HINT: (count: number) =>
    `Deletes every existing rule in this category on the ${count} selected rule set${count === 1 ? '' : 's'}. Nothing is added.`,
  ACCESS_RULE_BULK_MODE_REPLACE_HINT_EFFECTIVE_DATE: (count: number) =>
    `Overwrites the effective start/end dates on the ${count} selected rule set${count === 1 ? '' : 's'}, keeping each set’s own time.`,
  ACCESS_RULE_BULK_MODE_REPLACE_HINT_EFFECTIVE_TIME: (count: number) =>
    `Overwrites the effective time on the ${count} selected rule set${count === 1 ? '' : 's'}, keeping each set’s own dates.`,
  ACCESS_RULE_BULK_CATEGORY_EFFECTIVE_DATE: 'Effective Dates',
  ACCESS_RULE_BULK_CATEGORY_EFFECTIVE_TIME: 'Effective Time',
  ACCESS_RULE_BULK_CATEGORY_MAX_DAYS: 'Max Days',
  ACCESS_RULE_BULK_CATEGORY_BLACKOUT_RANGE: 'Blackout Date Ranges',
  ACCESS_RULE_BULK_CATEGORY_BLACKOUT_DOW: 'Blackout Days of Week',
  ACCESS_RULE_BULK_EDIT_EMPTY_STATE: 'Set a category above to Add or Replace, and its rules will appear here to edit.',
  ACCESS_RULE_BULK_EDIT_CLEAR_ONLY_STATE: 'The selected categories will be deleted on every selected rule set. There are no values to enter — continue to Review changes.',

  ACCESS_RULE_BULK_EDIT_REVIEW: 'Review changes…',
  ACCESS_RULE_BULK_EDIT_REVIEW_PENDING: 'Working…',
  ACCESS_RULE_BULK_EDIT_REVIEW_TITLE:
    'See what will change on each selected access rule set before saving',
  ACCESS_RULE_BULK_EDIT_BACK: 'Back to edit',
  ACCESS_RULE_BULK_EDIT_BACK_TITLE: 'Go back and change this edit',
  ACCESS_RULE_BULK_EDIT_SAVE_CONFIRMATION: 'Are you sure you want to apply these changes to all selected rule sets?',
  // Counts the rule sets the scan found will change, not the number selected.
  ACCESS_RULE_BULK_EDIT_APPLY_TO_COUNT: (count: number) =>
    `Apply to ${count} rule set${count === 1 ? '' : 's'}`,
  ACCESS_RULE_BULK_EDIT_APPLY_TO_COUNT_TITLE: (count: number) =>
    `Save this edit to ${count} access rule set${count === 1 ? '' : 's'}`,
  // Offered instead of "Apply to 0 rule sets" when the edit changes nothing.
  ACCESS_RULE_BULK_EDIT_CLOSE: 'Close',
  ACCESS_RULE_BULK_EDIT_CLOSE_TITLE: 'Close without changing any access rules',
  ACCESS_RULE_BULK_EDIT_APPLYING: 'Applying Access Rule Changes',
  ACCESS_RULE_BULK_EDIT_SAVE_ERROR: 'Some changes couldn’t be saved.',
  ACCESS_RULE_RULE_SETS: 'rule sets',

  // Post-save outcome screen: which rule sets didn't save, and why.
  ACCESS_RULE_BULK_EDIT_FAILURES_TITLE: 'Some changes couldn’t be saved',
  ACCESS_RULE_BULK_EDIT_FAILURES_SUCCEEDED: (count: number) => `${count} saved`,
  ACCESS_RULE_BULK_EDIT_FAILURES_FAILED: (count: number) => `${count} failed`,
  ACCESS_RULE_BULK_EDIT_FAILURES_NOT_ATTEMPTED: (count: number) =>
    `${count} not attempted`,
  ACCESS_RULE_BULK_EDIT_FAILURES_NOT_ATTEMPTED_NOTE: (count: number) =>
    `The run stopped, so ${count} rule set${count === 1 ? ' was' : 's were'} not attempted.`,
  ACCESS_RULE_BULK_EDIT_FAILURES_HINT: 'These rule sets couldn’t be saved.',
  ACCESS_RULE_BULK_EDIT_FAILURES_RETRY_NOTE:
    'The errors below look temporary — select Retry to try those rule sets again.',
  ACCESS_RULE_BULK_EDIT_FAILURES_FIX_NOTE:
    'Errors that aren’t temporary (like overlapping dates) won’t succeed on retry — close and correct those rule sets first.',
  ACCESS_RULE_BULK_EDIT_FAILURES_ERROR: 'Error',
  ACCESS_RULE_BULK_EDIT_FAILURES_HTTP: (status: number) => `HTTP ${status}`,
  ACCESS_RULE_BULK_EDIT_FAILURES_UNKNOWN: 'Save failed (no detail returned)',
  ACCESS_RULE_BULK_EDIT_FAILURES_RETRY: (count: number) => `Retry ${count} failed`,
  ACCESS_RULE_BULK_EDIT_FAILURES_RETRY_TITLE: (count: number) =>
    `Try saving the ${count} access rule set${count === 1 ? '' : 's'} that failed for a temporary reason`,
  // Neutral wording for a retry that also covers rule sets the run never attempted.
  ACCESS_RULE_BULK_RETRY_NOT_ATTEMPTED: (count: number) => `Retry ${count}`,
  ACCESS_RULE_BULK_RETRY_NOT_ATTEMPTED_TITLE: (count: number) =>
    `Try the ${count} rule set${count === 1 ? '' : 's'} that failed for a temporary reason or were not attempted`,
  ACCESS_RULE_BULK_EDIT_FAILURES_CLOSE_TITLE:
    'Close and refresh the access rules list',

  // Curated messages for the API's LiftAccessRuleErrorCode values.
  ACCESS_RULE_SAVE_ERROR_INVALID_ENTITLEMENT_TYPE: 'Entitlement type not found',
  ACCESS_RULE_SAVE_ERROR_INVALID_FULFILLMENT_SEASON: 'Fulfillment season not found',
  ACCESS_RULE_SAVE_ERROR_INVALID_SCOPE_CATEGORY: 'Invalid scope category',
  ACCESS_RULE_SAVE_ERROR_INVALID_SCOPE_ENTITY: 'Invalid resort or location for this rule',
  ACCESS_RULE_SAVE_ERROR_INVALID_DATE_RANGE: 'Invalid date range (expiration is before effective)',
  ACCESS_RULE_SAVE_ERROR_INVALID_TIME_RANGE: 'Invalid time range (end is before start)',
  ACCESS_RULE_SAVE_ERROR_RULE_ALREADY_EXISTS: 'A rule already exists for this context',
  ACCESS_RULE_SAVE_ERROR_RULE_NOT_FOUND: 'Rule not found — it may have been changed or removed',
  ACCESS_RULE_SAVE_ERROR_INVALID_RULE_ID: 'Invalid rule ID for this rule type',
  ACCESS_RULE_SAVE_ERROR_INVALID_DELETE_CRITERIA: 'Invalid delete request',
  ACCESS_RULE_SAVE_ERROR_MISSING_DAY_OF_WEEK: 'Day of week is required',
  ACCESS_RULE_SAVE_ERROR_CONFLICTING_DAY_OF_WEEK: 'Conflicting day-of-week values',
  ACCESS_RULE_SAVE_ERROR_INVALID_DAY_OF_WEEK: 'Invalid day of week',
  ACCESS_RULE_SAVE_ERROR_BLACKOUT_DATE_RANGE_OVERLAP: 'Blackout date ranges overlap',
  ACCESS_RULE_SAVE_ERROR_DATABASE: 'A database error occurred — please try again',
  ACCESS_RULE_SAVE_ERROR_OUTCOME_UNKNOWN:
    'Timed out — this may or may not have been applied. Retry to confirm, or re-run the search to check.',
  ACCESS_RULE_SAVE_ERROR_UNEXPECTED: 'An unexpected error occurred',
  ACCESS_RULE_SAVE_ERROR_REQUEST_NOT_SENT:
    'Not sent — too many failures in a row, so this rule set wasn’t attempted',
  ACCESS_RULE_BULK_EDIT_RESULTS_STALE:
    'These search results are too old to act on — another user may have changed these rule sets since. Search again to pick up the current rules.',
  ACCESS_RULE_BULK_EDIT_RESULTS_STALE_SHORT: 'Search again — these results are out of date',
  ACCESS_RULE_BULK_EDIT_NO_CHANGES: 'Select at least one category to change (Add or Replace).',
  ACCESS_RULE_BULK_EDIT_CATEGORY_EMPTY: 'Add at least one rule for each category set to Add or Replace.',
  ACCESS_RULE_BULK_EDIT_VALIDATION_ERROR_UNABLE_TO_SAVE: 'Please fix the highlighted rules and try again',

  ACCESS_RULE_BULK_SUMMARY_HEADING: 'What will change',
  ACCESS_RULE_BULK_SUMMARY_APPLIES: 'Applies to every selected rule set',
  ACCESS_RULE_BULK_SUMMARY_SET_EFFECTIVE_DATES: (dates: string) =>
    `Set effective dates to ${dates}`,
  ACCESS_RULE_BULK_SUMMARY_SET_EFFECTIVE_TIME: (time: string) =>
    `Set effective time to ${time}`,
  ACCESS_RULE_BULK_SUMMARY_SET_MAX_DAYS_SHARED_ADDED: (days: number) =>
    `Set max days to ${days} (shared usage added)`,
  ACCESS_RULE_BULK_SUMMARY_SET_MAX_DAYS_SHARED_REMOVED: (days: number) =>
    `Set max days to ${days} (shared usage removed)`,
  ACCESS_RULE_BULK_SUMMARY_ADD_BLACKOUT_RANGE: (dates: string, time: string) =>
    `Add blackout ${dates}, ${time}`,
  ACCESS_RULE_BULK_SUMMARY_ADD_BLACKOUT_DOW: (day: string, time: string) =>
    `Add ${day} blackout ${time}`,
  ACCESS_RULE_BULK_SUMMARY_REPLACE_NOTE:
    'Removes all existing rules in this category',
  ACCESS_RULE_BULK_SUMMARY_UNLIMITED: 'Unlimited',
  ACCESS_RULE_BULK_SUMMARY_AFFECTED_TOGGLE: (count: number) =>
    `Selected rule sets (${count})`,
  ACCESS_RULE_BULK_SUMMARY_RULE_SET_COLUMN: 'Rule set',
  ACCESS_RULE_SUMMARY_SHOW_ALL_COLUMNS: 'Show all columns',
  ACCESS_RULE_BULK_SUMMARY_CHANGING_LEGEND: 'Changed cells show before → after',
  ACCESS_RULE_BULK_SUMMARY_CHANGED_SR: 'Changed:',
  ACCESS_RULE_BULK_SUMMARY_NO_CHANGE_CELL: 'No change — this rule set already matches',
  ACCESS_RULE_BULK_SUMMARY_NO_CHANGE_ALL: 'No changes will be made — every selected rule set already matches these settings.',
  ACCESS_RULE_BULK_SUMMARY_NO_CHANGE_CATEGORY: 'No change — every selected rule set already matches',
  ACCESS_RULE_BULK_SUMMARY_UNAFFECTED: (unaffected: number, total: number) =>
    `${unaffected} of ${total} selected rule set${total === 1 ? '' : 's'} won’t change.`,
  ACCESS_RULE_BULK_SUMMARY_CLEAR_MAX_DAYS: 'Remove the max-days limit',
  ACCESS_RULE_BULK_SUMMARY_CLEAR_BLACKOUT_RANGE: 'Remove all blackout date ranges',
  ACCESS_RULE_BULK_SUMMARY_CLEAR_BLACKOUT_DOW: 'Remove all blackout days of week',

  ACCESS_RULE_BULK_EDIT_DISCARD_TITLE: 'Discard changes?',
  ACCESS_RULE_BULK_EDIT_DISCARD_BODY:
    'You have unsaved edits. Closing now will discard them.',
  ACCESS_RULE_BULK_EDIT_DISCARD_KEEP: 'Keep editing',
  ACCESS_RULE_BULK_EDIT_DISCARD_KEEP_TITLE: 'Go back to this edit and keep it',
  ACCESS_RULE_BULK_EDIT_DISCARD_CONFIRM: 'Discard',
  ACCESS_RULE_BULK_EDIT_DISCARD_CONFIRM_TITLE:
    'Close and lose this edit without saving',

  ACCESS_RULE_BULK_EDIT_POP_OUT: 'Pop out',
  ACCESS_RULE_BULK_EDIT_POP_OUT_TITLE:
    'Open in a separate window you can move to another monitor',
  ACCESS_RULE_BULK_EDIT_DOCK: '⇙ Dock to main window',
  ACCESS_RULE_BULK_EDIT_POPUP_BLOCKED:
    'Couldn’t open a pop-out window. Check your browser’s pop-up blocker and try again.',

  // The notice on the page a dialog was detached from — not the blocked-pop-up
  // message, which is ACCESS_RULE_BULK_EDIT_POPUP_BLOCKED above.
  POPOUT_NOTICE_HEADING: (title: string) =>
    `${title} is open in a separate window`,
  POPOUT_NOTICE_BODY:
    'This page stays visible but can’t be used until you finish there or dock it back.',
  POPOUT_NOTICE_SHOW_WINDOW: 'Show window',
  POPOUT_NOTICE_DOCK: '⇙ Dock to main window',

  ACCESS_RULE_EDIT_ADD_NEW: 'Add',
  ACCESS_RULE_EDIT_NEW_RULE: 'New rule',
  ACCESS_RULE_EDIT_BLACKOUT_DATE_RANGE: 'Blackout Date Range',
  ACCESS_RULE_EDIT_BLACKOUT_START_AND_END_REQUIED: 'Both a valid start date and a valid end date are required',
  ACCESS_RULE_EDIT_BLACKOUT_START_DATE_REQUIRED: 'A valid start date is required',
  ACCESS_RULE_EDIT_BLACKOUT_END_DATE_REQUIRED: 'A valid end date is required',
  ACCESS_RULE_EDIT_BLACKOUT_START_AFTER_END: 'The blackout must end on or after the start date',
  ACCESS_RULE_EDIT_BLACKOUT_START_BEFORE_EFFECTIVE_START: 'Warning: The blackout start date is outside of the effective start date',
  ACCESS_RULE_EDIT_BLACKOUT_END_AFTER_EFFECTIVE_END: 'Warning: The blackout end date is outside of the effective expire date',
  ACCESS_RULE_EDIT_SAVE_CONFIRMATION: 'Are you sure you want to save access rules?',
  ACCESS_RULE_DATA_CHANGE_WARNING : 'Any changes could affect live validations',
  ACCESS_RULE_VALIDATION_MAX_DAYS_MIN: 'Max days must be greater than 0',
  ACCESS_RULE_VALIDATION_MAX_DAYS_REQUIRED: 'Max days is required if shared is selected',
  ACCESS_RULE_VALIDATION_BLACKOUT_DATE_REQUIRED_FIELD_MISSING: 'Blackout date range is missing required fields',
  ACCESS_RULE_VALIDATION_BLACKOUT_DATE_RANGE_DATE_START_BEFORE_END: 'Blackout date range end date must be on or after blackout start date',
  ACCESS_RULE_VALIDATION_BLACKOUT_DATE_RANGE_TIME_START_BEFORE_END: 'Blackout date range start time must be before end time',
  ACCESS_RULE_VALIDATION_EFFECTIVE_DATE_REQUIRED_FIELD_MISSING: 'Effective date range is missing required fields',
  ACCESS_RULE_VALIDATION_EFFECTIVE_DATE_RANGE_DATE_START_BEFORE_END: 'Effective expire date must be on or after effective start date',
  ACCESS_RULE_VALIDATION_EFFECTIVE_DATE_RANGE_TIME_START_BEFORE_END: 'Effective start time must be before end time',
  ACCESS_RULE_VALIDATION_BLACKOUT_DOW_REQUIRED_FIELD_MISSING: 'Blackout day of week is missing required fields',
  ACCESS_RULE_VALIDATION_BLACKOUT_DOW_TIME_START_BEFORE_END: 'Blackout day of week start time must be before end time',
  ACCESS_RULE_BLACKOUT_DAY_OF_WEEK_EMPTY_GROUP_ERROR: 'At least one day of week must be selected',
  ACCESS_RULE_EDIT_BLACKOUT_DATE_RANGE_OVERLAP: 'Blackout date range overlaps with another access rule',
  ACCESS_RULE_EDIT_VALIDATION_ERROR_UNABLE_TO_SAVE: 'Cannot save access rules with errors.  Please resolve all errors and try again',
  ACCESS_RULE_SAVE_ERROR: 'An error occured while saving access rules.  Please review rules and try again.',
  ACCESS_RULE_EDIT_NO_CHANGES_FOUND: 'No access rule changes found',
  ACCESS_RULE_EDIT_CHANGES_SAVED: 'Access rule changes saved',
  ACCESS_OVERVIEW_ADD_TITLE: 'Add new access rules',
  ACCESS_OVERVIEW_ADD: 'ADD',
  ACCESS_RULE_ADD_MODAL_TITLE: 'Add Access Rules',
  ACCESS_RULE_ADD_SAVE_CONFIRMATION: 'Are you sure you want to add access rules?',
  ACCESS_RULE_NO_SELLING_SEASONS: 'No selling seasons',
  ACCESS_RULE_NO_FULFILLMENT_SEASONS: 'No fulfillment seasons',
  ACCESS_RULE_ADD_ENTITELEMENT: 'Entitlement:',
  ACCESS_RULE_ADD_ENTITLEMENT_TYPES: 'Entitlement Types',
  ACCESS_RULE_PLEASE_SELECT: 'Please select...',
  ACCESS_RULE_ADD_HEADER_VALIDATION_ERROR_UNABLE_TO_SAVE: 'Please fill out all required fields and try again',
  ACCESS_RULE_ADD_CREATED_RULES_SAVED: 'Access rule additions saved',
  ACCESS_RULE_ADD_SAVE_ERROR: 'Some rule sets couldn’t be added.',
  ACCESS_RULE_ADD_VALIDATION_UNEXPECTED_ERROR: 'An unexpected error occurred trying to save new access rules',
  ACCESS_RULE_ADD_ADDING_ACCESS_RULES: 'Adding Lift Access Rules',
  ACCESS_RULE_ENTITLEMENT_RULE_SETS: 'entitlement rule sets',

  // Bulk add outcome screen. Add-flavoured wording for the same screen the bulk edit
  // and bulk delete runs report through.
  ACCESS_RULE_BULK_ADD_FAILURES_TITLE: 'Some rule sets couldn’t be added',
  ACCESS_RULE_BULK_ADD_STOPPED_TITLE: 'Add stopped',
  ACCESS_RULE_BULK_ADD_CANCELLED_TITLE: 'Add stopped',
  ACCESS_RULE_BULK_ADD_FAILURES_SUCCEEDED: (count: number) => `${count} added`,
  ACCESS_RULE_BULK_ADD_FAILURES_HINT:
    'These rule sets couldn’t be added — check the reason for each. Any rule set not listed here was added.',
  ACCESS_RULE_BULK_ADD_FAILURES_FIX_NOTE:
    'Errors that aren’t temporary (like a rule set that already exists) won’t succeed on retry — close and correct those rule sets first.',
  ACCESS_RULE_BULK_ADD_FAILURES_UNKNOWN: 'Add failed (no detail returned)',
  ACCESS_RULE_BULK_ADD_FAILURES_RETRY_TITLE: (count: number) =>
    `Try adding the ${count} rule set${count === 1 ? '' : 's'} that failed for a temporary reason`,
  // Cancelling is not a failure: no errors, nothing to fix, just an unfinished run.
  // It still has to say the rule sets added before the stop are there.
  ACCESS_RULE_BULK_ADD_CANCELLED_NOTE: (notAttempted: number) =>
    `You stopped the run, so ${notAttempted} rule set${notAttempted === 1 ? ' was' : 's were'} not attempted. The rule sets counted as added above are already saved.`,
  ACCESS_RULE_DELETE_ACCESS_RULES: 'Delete Access Rules?',
  ACCESS_RULE_SET_DELETE_CONFIRMATION: 'This will delete the access rules for the following set.',
  ACCESS_RULE_DELETE_CONFIRMATION: 'This will delete the selected access rules.  Are you sure you want to delete?',
  ACCESS_RULE_DELETE_QUESTION: 'Are you sure you want to delete?',
  ACCESS_RULE_DELETE_SUMMARY_WARNING: (count: number) =>
    `Permanently deletes ${count} rule set${count === 1 ? '' : 's'} and all their rules — this can't be undone.`,
  ACCESS_RULE_DELETE_SUMMARY_TOGGLE: (count: number) =>
    `Rule sets to delete (${count})`,
  ACCESS_RULE_BULK_DELETE_CONFIRMATION:
    'Are you sure you want to delete all selected rule sets?',
  ACCESS_RULE_BULK_DELETE_CONFIRM_LABEL: 'Confirm deletion',
  // Arms the Delete button — translate together with the hints below, since the
  // gate compares against this value.
  ACCESS_RULE_BULK_DELETE_CONFIRM_PHRASE: 'delete',
  ACCESS_RULE_BULK_DELETE_CONFIRM_HINT: (phrase: string) =>
    `Type ${phrase} to confirm`,
  ACCESS_RULE_BULK_DELETE_CONFIRM_MISMATCH: (phrase: string) =>
    `Doesn’t match — type ${phrase} to confirm`,
  ACCESS_RULE_DELETE_ERROR: 'An error occured while deleting access rules.',
  ACCESS_RULE_DELETE_SUCCESS: 'Access rules deleted',
  ACCESS_RULE_DELETE_SUCCESS_COUNT: (count: number) =>
    `${count} rule set${count === 1 ? '' : 's'} deleted`,
  // Shown on the bulk actions while a delete run is in flight.
  ACCESS_RULE_BULK_DELETE_PENDING_TITLE:
    'A delete is already running — wait for it to finish',
  ACCESS_RULE_BULK_DELETE_TOO_MANY_TITLE: (max: number) =>
    `Select ${max} rule sets or fewer to delete in one go`,
  // Bulk delete run: the delete is sent in chunks, so progress advances a chunk at a
  // time and is counted in rule sets.
  ACCESS_RULE_BULK_DELETE_DELETING: 'Deleting access rules',
  ACCESS_RULE_BULK_DELETE_ERROR_SUMMARY:
    'Some rule sets couldn’t be deleted. Deletions that did go through can’t be undone.',

  // Bulk delete outcome screen. Delete-flavoured throughout: the shared save copy
  // reads as work not done, where here it is work already done and irreversible.
  // "not confirmed deleted", not "not deleted": a timed-out chunk may have committed
  // server-side, so the only honest claim is that the outcome wasn't confirmed. The
  // per-row reason says which case each one is.
  ACCESS_RULE_BULK_DELETE_FAILURES_TITLE: 'Some rule sets weren’t confirmed deleted',
  ACCESS_RULE_BULK_DELETE_STOPPED_TITLE: 'Delete stopped',
  ACCESS_RULE_BULK_DELETE_CANCELLED_TITLE: 'Delete stopped',
  ACCESS_RULE_BULK_DELETE_FAILURES_SUCCEEDED: (count: number) =>
    `${count} deleted`,
  // No claim about rule sets that aren't listed beyond the one that matters: they
  // are gone. A cancelled or stopped run leaves others unattempted, covered below.
  ACCESS_RULE_BULK_DELETE_FAILURES_HINT:
    'These rule sets weren’t confirmed deleted — check the reason for each. Any rule set not listed here was deleted and can’t be recovered.',
  ACCESS_RULE_BULK_DELETE_FAILURES_FIX_NOTE:
    'Errors that aren’t temporary won’t succeed on retry — close and check those rule sets individually.',
  ACCESS_RULE_BULK_DELETE_FAILURES_UNKNOWN: 'Delete failed (no detail returned)',
  ACCESS_RULE_BULK_DELETE_FAILURES_RETRY_TITLE: (count: number) =>
    `Try deleting the ${count} rule set${count === 1 ? '' : 's'} that failed for a temporary reason`,
  // Cancelling is not a failure: no errors, nothing to fix, just an unfinished run —
  // but for a delete it must not read as "nothing happened".
  ACCESS_RULE_BULK_DELETE_CANCELLED_NOTE: (notAttempted: number) =>
    `You stopped the run, so ${notAttempted} rule set${notAttempted === 1 ? ' was' : 's were'} not attempted. The rule sets counted as deleted above are already gone and can’t be recovered.`,

  // Progress card, delete wording. The shared strings are written for a save, where
  // stopping means work not done; stopping a delete means work already done.
  ACCESS_RULE_BULK_DELETE_CANCELLING_HINT:
    'Finishing the batch in progress — those rule sets will still be deleted.',
  ACCESS_RULE_BULK_DELETE_CANCELLED_MESSAGE: (deleted: number, notAttempted: number) =>
    `${deleted} rule set${deleted === 1 ? '' : 's'} ${deleted === 1 ? 'was' : 'were'} deleted and can’t be recovered. ${notAttempted} ${notAttempted === 1 ? 'was' : 'were'} not attempted.`,
  ACCESS_RULE_BULK_DELETE_RETRY_CONFIRM: (count: number) =>
    `This will try again to delete ${count} rule set${count === 1 ? '' : 's'}. Deleting can’t be undone.`,

  TIME_RANGE_INPUT_START_BEFORE_END: 'Start time must be before end time',
  TIME_RANGE_INPUT_START_REQUIRED: 'Start time is required',
  TIME_RANGE_INPUT_END_REQUIRED: 'End time is required',
  TIME_RANGE_INPUT_START_END_REQUIRED: 'Both start time and end time are required',
  TIME_RANGE_INPUT_UNKNOWN_VALIDATION_ERROR: 'Unknown time validation error',

  BULK_PROGRESS_CLOSE: 'Close',
  BULK_PROGRESS_CANCEL: 'Cancel',
  BULK_PROGRESS_CANCELLED: 'Cancelled',
  BULK_PROGRESS_CANCELLING: 'Cancelling...',
  BULK_PROGRESS_REQUESTS: 'requests',
  BULK_PROGRESS_CANCELLING_HINT: 'Finishing in progress requests...',
  BULK_PROGRESS_CANCELLED_MESSAGE: (itemText: string) => `This operation was cancelled before all ${itemText} were processed.`,
  BULK_PROGRESS_DONE: 'Done',
  BULK_PROGRESS_SUCCEEDED: 'Succeeded',
  BULK_PROGRESS_FAILED: 'Failed',
  BULK_PROGRESS_NOT_PROCESSED: 'Not processed',
  BULK_PROGRESS_STARTING: 'Starting...',
  BULK_PROGRESS_ALMOST_DONE: 'Almost done...',
  BULK_PROGRESS_COMPLETED_SUCCESSFULLY: 'Completed successfully',
  BULK_PROGRESS_COMPLETED_WITH_FAILURES: 'Completed with failures',
  BULK_PROGRESS_SECONDS_REMAINING: (seconds: number) => `~${seconds}s remaining`,
}

export default en_us;
